var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));

// src/index.ts
var src_exports = {};
__export(src_exports, {
  Accordion: () => Accordion,
  AccordionContent: () => AccordionContent,
  AccordionItem: () => AccordionItem,
  AccordionTrigger: () => AccordionTrigger,
  AgGridReact: () => AgGridReact,
  AlertDialog: () => AlertDialog,
  AlertDialogAction: () => AlertDialogAction,
  AlertDialogCancel: () => AlertDialogCancel,
  AlertDialogContent: () => AlertDialogContent,
  AlertDialogDescription: () => AlertDialogDescription,
  AlertDialogFooter: () => AlertDialogFooter,
  AlertDialogHeader: () => AlertDialogHeader,
  AlertDialogOverlay: () => AlertDialogOverlay,
  AlertDialogPortal: () => AlertDialogPortal,
  AlertDialogTitle: () => AlertDialogTitle,
  AlertDialogTrigger: () => AlertDialogTrigger,
  AutoComplete: () => AutoComplete,
  Avatar: () => Avatar,
  AvatarFallback: () => AvatarFallback,
  AvatarImage: () => AvatarImage,
  AverageLine: () => AverageLine,
  Badge: () => Badge,
  Breadcrumb: () => Breadcrumb,
  BreadcrumbEllipsis: () => BreadcrumbEllipsis,
  BreadcrumbItem: () => BreadcrumbItem,
  BreadcrumbLink: () => BreadcrumbLink,
  BreadcrumbList: () => BreadcrumbList,
  BreadcrumbPage: () => BreadcrumbPage,
  BreadcrumbSeparator: () => BreadcrumbSeparator,
  Button: () => Button,
  Calendar: () => Calendar,
  Callout: () => Callout,
  CalloutIcon: () => CalloutIcon,
  CalloutTitle: () => CalloutTitle,
  Card: () => Card,
  CardContent: () => CardContent,
  CardDescription: () => CardDescription,
  CardFooter: () => CardFooter,
  CardHeader: () => CardHeader,
  CardTitle: () => CardTitle,
  Chart: () => Chart,
  ChartCustomTooltip: () => ChartCustomTooltip,
  Checkbox: () => Checkbox,
  Collapsible: () => Collapsible,
  CollapsibleContent: () => CollapsibleContent,
  CollapsibleTrigger: () => CollapsibleTrigger,
  Command: () => Command,
  CommandDialog: () => CommandDialog,
  CommandEmpty: () => CommandEmpty,
  CommandGroup: () => CommandGroup,
  CommandInput: () => CommandInput,
  CommandItem: () => CommandItem,
  CommandList: () => CommandList,
  CommandSeparator: () => CommandSeparator,
  CommandShortcut: () => CommandShortcut,
  CopyToClipboard: () => CopyToClipboard,
  DatePicker: () => DatePicker,
  Dialog: () => Dialog,
  DialogClose: () => DialogClose,
  DialogContent: () => DialogContent,
  DialogDescription: () => DialogDescription,
  DialogFooter: () => DialogFooter,
  DialogHeader: () => DialogHeader,
  DialogOverlay: () => DialogOverlay,
  DialogPortal: () => DialogPortal,
  DialogTitle: () => DialogTitle,
  DialogTrigger: () => DialogTrigger,
  DropdownMenu: () => DropdownMenu,
  DropdownMenuCheckboxItem: () => DropdownMenuCheckboxItem,
  DropdownMenuContent: () => DropdownMenuContent,
  DropdownMenuGroup: () => DropdownMenuGroup,
  DropdownMenuItem: () => DropdownMenuItem,
  DropdownMenuLabel: () => DropdownMenuLabel,
  DropdownMenuPortal: () => DropdownMenuPortal,
  DropdownMenuRadioGroup: () => DropdownMenuRadioGroup,
  DropdownMenuRadioItem: () => DropdownMenuRadioItem,
  DropdownMenuSeparator: () => DropdownMenuSeparator,
  DropdownMenuShortcut: () => DropdownMenuShortcut,
  DropdownMenuSub: () => DropdownMenuSub,
  DropdownMenuSubContent: () => DropdownMenuSubContent,
  DropdownMenuSubTrigger: () => DropdownMenuSubTrigger,
  DropdownMenuTrigger: () => DropdownMenuTrigger,
  EmptyState: () => EmptyState,
  Form: () => Form,
  FormControl: () => FormControl,
  FormDescription: () => FormDescription,
  FormField: () => FormField,
  FormFieldReadOnly: () => FormFieldReadOnly,
  FormItem: () => FormItem,
  FormLabel: () => FormLabel,
  FormMessage: () => FormMessage,
  HoverCard: () => HoverCard,
  HoverCardContent: () => HoverCardContent,
  HoverCardTrigger: () => HoverCardTrigger,
  Icon: () => Icon,
  Input: () => Input,
  InputAddon: () => InputAddon,
  Label: () => Label2,
  LicenseManager: () => LicenseManager,
  Logo: () => Logo,
  ModeToggle: () => ModeToggle,
  MoneyCell: () => money_cell_default,
  MultiSelect: () => MultiSelect,
  MultiSelectBadge: () => MultiSelectBadge2,
  NavigationMenu: () => NavigationMenu,
  NavigationMenuContent: () => NavigationMenuContent,
  NavigationMenuIndicator: () => NavigationMenuIndicator,
  NavigationMenuItem: () => NavigationMenuItem,
  NavigationMenuLink: () => NavigationMenuLink,
  NavigationMenuList: () => NavigationMenuList,
  NavigationMenuTrigger: () => NavigationMenuTrigger,
  NavigationMenuViewport: () => NavigationMenuViewport,
  Pagination: () => Pagination,
  PaginationCompact: () => PaginationCompact,
  PaginationContent: () => PaginationContent,
  PaginationEllipsis: () => PaginationEllipsis,
  PaginationItem: () => PaginationItem,
  PaginationLink: () => PaginationLink,
  PaginationNext: () => PaginationNext,
  PaginationPrevious: () => PaginationPrevious,
  Popover: () => Popover,
  PopoverContent: () => PopoverContent,
  PopoverSelect: () => PopoverSelect,
  PopoverTrigger: () => PopoverTrigger,
  RadioGroup: () => RadioGroup2,
  RadioGroupItem: () => RadioGroupItem,
  Ratings: () => Ratings,
  ScrollArea: () => ScrollArea,
  ScrollBar: () => ScrollBar,
  Select: () => Select,
  SelectContent: () => SelectContent,
  SelectGroup: () => SelectGroup,
  SelectItem: () => SelectItem,
  SelectLabel: () => SelectLabel,
  SelectScrollDownButton: () => SelectScrollDownButton,
  SelectScrollUpButton: () => SelectScrollUpButton,
  SelectSeparator: () => SelectSeparator,
  SelectTrigger: () => SelectTrigger,
  SelectValue: () => SelectValue,
  Separator: () => Separator3,
  Sheet: () => Sheet,
  SheetClose: () => SheetClose,
  SheetContent: () => SheetContent,
  SheetDescription: () => SheetDescription,
  SheetFooter: () => SheetFooter,
  SheetHeader: () => SheetHeader,
  SheetOverlay: () => SheetOverlay,
  SheetPortal: () => SheetPortal,
  SheetTitle: () => SheetTitle,
  SheetTrigger: () => SheetTrigger,
  Skeleton: () => Skeleton,
  Sonner: () => Sonner,
  Stars: () => Stars,
  Switch: () => Switch,
  Table: () => Table,
  TableBody: () => TableBody,
  TableCaption: () => TableCaption,
  TableCell: () => TableCell,
  TableFooter: () => TableFooter,
  TableHead: () => TableHead,
  TableHeader: () => TableHeader,
  TableRow: () => TableRow,
  Tabs: () => Tabs,
  TabsContent: () => TabsContent,
  TabsList: () => TabsList,
  TabsTrigger: () => TabsTrigger,
  Textarea: () => Textarea,
  ThemeProvider: () => ThemeProvider,
  Toast: () => Toast,
  ToastAction: () => ToastAction,
  ToastClose: () => ToastClose,
  ToastDescription: () => ToastDescription,
  ToastProvider: () => ToastProvider,
  ToastTitle: () => ToastTitle,
  ToastViewport: () => ToastViewport,
  Toaster: () => Toaster,
  Tooltip: () => Tooltip,
  TooltipContent: () => TooltipContent,
  TooltipProvider: () => TooltipProvider,
  TooltipTrigger: () => TooltipTrigger,
  badgeVariants: () => badgeVariants,
  buttonVariants: () => buttonVariants,
  cn: () => cn,
  defaultInitials: () => defaultInitials,
  format: () => format,
  formatDate: () => formatDate,
  formatDatetime: () => formatDatetime,
  getRandomColor: () => getRandomColor,
  inputDatetimeFormatOptions: () => inputDatetimeFormatOptions,
  navigationMenuTriggerStyle: () => navigationMenuTriggerStyle,
  reducer: () => reducer,
  sonner: () => sonner,
  toast: () => toast,
  useFormField: () => useFormField,
  useTheme: () => useTheme,
  useToast: () => useToast
});
import "@uturn/design-tokens/base.css";

// src/components/index.ts
var components_exports = {};
__export(components_exports, {
  Accordion: () => Accordion,
  AccordionContent: () => AccordionContent,
  AccordionItem: () => AccordionItem,
  AccordionTrigger: () => AccordionTrigger,
  AgGridReact: () => AgGridReact,
  AlertDialog: () => AlertDialog,
  AlertDialogAction: () => AlertDialogAction,
  AlertDialogCancel: () => AlertDialogCancel,
  AlertDialogContent: () => AlertDialogContent,
  AlertDialogDescription: () => AlertDialogDescription,
  AlertDialogFooter: () => AlertDialogFooter,
  AlertDialogHeader: () => AlertDialogHeader,
  AlertDialogOverlay: () => AlertDialogOverlay,
  AlertDialogPortal: () => AlertDialogPortal,
  AlertDialogTitle: () => AlertDialogTitle,
  AlertDialogTrigger: () => AlertDialogTrigger,
  AutoComplete: () => AutoComplete,
  Avatar: () => Avatar,
  AvatarFallback: () => AvatarFallback,
  AvatarImage: () => AvatarImage,
  AverageLine: () => AverageLine,
  Badge: () => Badge,
  Breadcrumb: () => Breadcrumb,
  BreadcrumbEllipsis: () => BreadcrumbEllipsis,
  BreadcrumbItem: () => BreadcrumbItem,
  BreadcrumbLink: () => BreadcrumbLink,
  BreadcrumbList: () => BreadcrumbList,
  BreadcrumbPage: () => BreadcrumbPage,
  BreadcrumbSeparator: () => BreadcrumbSeparator,
  Button: () => Button,
  Calendar: () => Calendar,
  Callout: () => Callout,
  CalloutIcon: () => CalloutIcon,
  CalloutTitle: () => CalloutTitle,
  Card: () => Card,
  CardContent: () => CardContent,
  CardDescription: () => CardDescription,
  CardFooter: () => CardFooter,
  CardHeader: () => CardHeader,
  CardTitle: () => CardTitle,
  Chart: () => Chart,
  ChartCustomTooltip: () => ChartCustomTooltip,
  Checkbox: () => Checkbox,
  Collapsible: () => Collapsible,
  CollapsibleContent: () => CollapsibleContent,
  CollapsibleTrigger: () => CollapsibleTrigger,
  Command: () => Command,
  CommandDialog: () => CommandDialog,
  CommandEmpty: () => CommandEmpty,
  CommandGroup: () => CommandGroup,
  CommandInput: () => CommandInput,
  CommandItem: () => CommandItem,
  CommandList: () => CommandList,
  CommandSeparator: () => CommandSeparator,
  CommandShortcut: () => CommandShortcut,
  CopyToClipboard: () => CopyToClipboard,
  DatePicker: () => DatePicker,
  Dialog: () => Dialog,
  DialogClose: () => DialogClose,
  DialogContent: () => DialogContent,
  DialogDescription: () => DialogDescription,
  DialogFooter: () => DialogFooter,
  DialogHeader: () => DialogHeader,
  DialogOverlay: () => DialogOverlay,
  DialogPortal: () => DialogPortal,
  DialogTitle: () => DialogTitle,
  DialogTrigger: () => DialogTrigger,
  DropdownMenu: () => DropdownMenu,
  DropdownMenuCheckboxItem: () => DropdownMenuCheckboxItem,
  DropdownMenuContent: () => DropdownMenuContent,
  DropdownMenuGroup: () => DropdownMenuGroup,
  DropdownMenuItem: () => DropdownMenuItem,
  DropdownMenuLabel: () => DropdownMenuLabel,
  DropdownMenuPortal: () => DropdownMenuPortal,
  DropdownMenuRadioGroup: () => DropdownMenuRadioGroup,
  DropdownMenuRadioItem: () => DropdownMenuRadioItem,
  DropdownMenuSeparator: () => DropdownMenuSeparator,
  DropdownMenuShortcut: () => DropdownMenuShortcut,
  DropdownMenuSub: () => DropdownMenuSub,
  DropdownMenuSubContent: () => DropdownMenuSubContent,
  DropdownMenuSubTrigger: () => DropdownMenuSubTrigger,
  DropdownMenuTrigger: () => DropdownMenuTrigger,
  EmptyState: () => EmptyState,
  Form: () => Form,
  FormControl: () => FormControl,
  FormDescription: () => FormDescription,
  FormField: () => FormField,
  FormFieldReadOnly: () => FormFieldReadOnly,
  FormItem: () => FormItem,
  FormLabel: () => FormLabel,
  FormMessage: () => FormMessage,
  HoverCard: () => HoverCard,
  HoverCardContent: () => HoverCardContent,
  HoverCardTrigger: () => HoverCardTrigger,
  Icon: () => Icon,
  Input: () => Input,
  InputAddon: () => InputAddon,
  Label: () => Label2,
  LicenseManager: () => LicenseManager,
  Logo: () => Logo,
  ModeToggle: () => ModeToggle,
  MoneyCell: () => money_cell_default,
  MultiSelect: () => MultiSelect,
  MultiSelectBadge: () => MultiSelectBadge2,
  NavigationMenu: () => NavigationMenu,
  NavigationMenuContent: () => NavigationMenuContent,
  NavigationMenuIndicator: () => NavigationMenuIndicator,
  NavigationMenuItem: () => NavigationMenuItem,
  NavigationMenuLink: () => NavigationMenuLink,
  NavigationMenuList: () => NavigationMenuList,
  NavigationMenuTrigger: () => NavigationMenuTrigger,
  NavigationMenuViewport: () => NavigationMenuViewport,
  Pagination: () => Pagination,
  PaginationCompact: () => PaginationCompact,
  PaginationContent: () => PaginationContent,
  PaginationEllipsis: () => PaginationEllipsis,
  PaginationItem: () => PaginationItem,
  PaginationLink: () => PaginationLink,
  PaginationNext: () => PaginationNext,
  PaginationPrevious: () => PaginationPrevious,
  Popover: () => Popover,
  PopoverContent: () => PopoverContent,
  PopoverSelect: () => PopoverSelect,
  PopoverTrigger: () => PopoverTrigger,
  RadioGroup: () => RadioGroup2,
  RadioGroupItem: () => RadioGroupItem,
  Ratings: () => Ratings,
  ScrollArea: () => ScrollArea,
  ScrollBar: () => ScrollBar,
  Select: () => Select,
  SelectContent: () => SelectContent,
  SelectGroup: () => SelectGroup,
  SelectItem: () => SelectItem,
  SelectLabel: () => SelectLabel,
  SelectScrollDownButton: () => SelectScrollDownButton,
  SelectScrollUpButton: () => SelectScrollUpButton,
  SelectSeparator: () => SelectSeparator,
  SelectTrigger: () => SelectTrigger,
  SelectValue: () => SelectValue,
  Separator: () => Separator3,
  Sheet: () => Sheet,
  SheetClose: () => SheetClose,
  SheetContent: () => SheetContent,
  SheetDescription: () => SheetDescription,
  SheetFooter: () => SheetFooter,
  SheetHeader: () => SheetHeader,
  SheetOverlay: () => SheetOverlay,
  SheetPortal: () => SheetPortal,
  SheetTitle: () => SheetTitle,
  SheetTrigger: () => SheetTrigger,
  Skeleton: () => Skeleton,
  Sonner: () => Sonner,
  Stars: () => Stars,
  Switch: () => Switch,
  Table: () => Table,
  TableBody: () => TableBody,
  TableCaption: () => TableCaption,
  TableCell: () => TableCell,
  TableFooter: () => TableFooter,
  TableHead: () => TableHead,
  TableHeader: () => TableHeader,
  TableRow: () => TableRow,
  Tabs: () => Tabs,
  TabsContent: () => TabsContent,
  TabsList: () => TabsList,
  TabsTrigger: () => TabsTrigger,
  Textarea: () => Textarea,
  ThemeProvider: () => ThemeProvider,
  Toast: () => Toast,
  ToastAction: () => ToastAction,
  ToastClose: () => ToastClose,
  ToastDescription: () => ToastDescription,
  ToastProvider: () => ToastProvider,
  ToastTitle: () => ToastTitle,
  ToastViewport: () => ToastViewport,
  Toaster: () => Toaster,
  Tooltip: () => Tooltip,
  TooltipContent: () => TooltipContent,
  TooltipProvider: () => TooltipProvider,
  TooltipTrigger: () => TooltipTrigger,
  badgeVariants: () => badgeVariants,
  buttonVariants: () => buttonVariants,
  format: () => format,
  formatDate: () => formatDate,
  formatDatetime: () => formatDatetime,
  inputDatetimeFormatOptions: () => inputDatetimeFormatOptions,
  navigationMenuTriggerStyle: () => navigationMenuTriggerStyle,
  reducer: () => reducer,
  sonner: () => sonner,
  toast: () => toast,
  useFormField: () => useFormField,
  useTheme: () => useTheme,
  useToast: () => useToast
});

// src/components/accordion/accordion.tsx
import * as AccordionPrimitive from "@radix-ui/react-accordion";
import { ChevronDown } from "lucide-react";
import * as React from "react";

// src/utils/index.ts
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
function cn(...inputs) {
  return twMerge(clsx(inputs));
}
function defaultInitials(name, { maxInitials = 2 }) {
  return name.split(/\s/).map((part) => part.substring(0, 1).toUpperCase()).filter((v) => !!v).slice(0, maxInitials).join("").toUpperCase();
}
var colors = [
  "#A62A21",
  "#7e3794",
  "#0B51C1",
  "#3A6024",
  "#A81563",
  "#B3003C"
];
function _stringAsciiPRNG(value, m) {
  const charCodes = [...value].map((letter) => letter.charCodeAt(0));
  const len = charCodes.length;
  const a = len % (m - 1) + 1;
  const c = charCodes.reduce((current, next) => current + next) % m;
  let random = charCodes[0] % m;
  for (let i = 0; i < len; i++)
    random = (a * random + c) % m;
  return random;
}
function getRandomColor(value) {
  if (!value) {
    return "red-500";
  }
  const colorIndex = _stringAsciiPRNG(value, colors.length);
  return colors[colorIndex];
}

// src/components/accordion/accordion.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var Accordion = AccordionPrimitive.Root;
var AccordionItem = React.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx(
    AccordionPrimitive.Item,
    __spreadValues({
      ref,
      className: cn("border-b", className)
    }, props)
  );
});
AccordionItem.displayName = "AccordionItem";
var AccordionTrigger = React.forwardRef((_a, ref) => {
  var _b = _a, { className, children } = _b, props = __objRest(_b, ["className", "children"]);
  return /* @__PURE__ */ jsx(AccordionPrimitive.Header, { className: "flex", children: /* @__PURE__ */ jsxs(
    AccordionPrimitive.Trigger,
    __spreadProps(__spreadValues({
      ref,
      className: cn(
        "flex flex-1 items-center justify-between py-4 font-medium transition-all hover:underline [&[data-state=open]>svg]:rotate-180",
        className
      )
    }, props), {
      children: [
        children,
        /* @__PURE__ */ jsx(ChevronDown, { className: "h-4 w-4 shrink-0 transition-transform duration-200" })
      ]
    })
  ) });
});
AccordionTrigger.displayName = AccordionPrimitive.Trigger.displayName;
var AccordionContent = React.forwardRef((_a, ref) => {
  var _b = _a, { className, children } = _b, props = __objRest(_b, ["className", "children"]);
  return /* @__PURE__ */ jsx(
    AccordionPrimitive.Content,
    __spreadProps(__spreadValues({
      ref,
      className: "overflow-hidden text-sm transition-all data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down"
    }, props), {
      children: /* @__PURE__ */ jsx("div", { className: cn("pb-4 pt-0", className), children })
    })
  );
});
AccordionContent.displayName = AccordionPrimitive.Content.displayName;

// src/components/avatar/avatar.tsx
import * as AvatarPrimitive from "@radix-ui/react-avatar";
import * as React2 from "react";
import { jsx as jsx2 } from "react/jsx-runtime";
var Avatar = React2.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx2(
    AvatarPrimitive.Root,
    __spreadValues({
      ref,
      className: cn(
        "relative flex h-10 w-10 shrink-0 overflow-hidden rounded-full",
        className
      )
    }, props)
  );
});
Avatar.displayName = AvatarPrimitive.Root.displayName;
var AvatarImage = React2.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx2(
    AvatarPrimitive.Image,
    __spreadValues({
      ref,
      className: cn("aspect-square h-full w-full", className)
    }, props)
  );
});
AvatarImage.displayName = AvatarPrimitive.Image.displayName;
var AvatarFallback = React2.forwardRef((_a, ref) => {
  var _b = _a, { className, name, children } = _b, props = __objRest(_b, ["className", "name", "children"]);
  return /* @__PURE__ */ jsx2(
    AvatarPrimitive.Fallback,
    __spreadProps(__spreadValues({
      ref,
      className: cn(
        "flex h-full w-full items-center justify-center rounded-full bg-muted",
        name && `bg-[${getRandomColor(name)}] text-white`,
        className
      )
    }, props), {
      children: name ? defaultInitials(name, { maxInitials: 2 }) : children
    })
  );
});
AvatarFallback.displayName = AvatarPrimitive.Fallback.displayName;

// src/components/alert-dialog/alert-dialog.tsx
import * as AlertDialogPrimitive from "@radix-ui/react-alert-dialog";
import * as React4 from "react";

// src/components/button/button.tsx
import { Slot } from "@radix-ui/react-slot";
import { cva } from "class-variance-authority";
import * as React3 from "react";
import { jsx as jsx3 } from "react/jsx-runtime";
var buttonVariants = cva(
  "inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground hover:bg-primary/90",
        destructive: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
        outline: "border border-input bg-card hover:bg-accent hover:text-accent-foreground",
        secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        link: "text-primary underline-offset-4 hover:underline"
      },
      size: {
        default: "h-10 px-4 py-2",
        xs: "h-8 px-2 py-2 text-sm",
        sm: "h-9 rounded-md px-3",
        lg: "h-11 rounded-md px-8",
        icon: "h-10 w-10"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
);
var Button = React3.forwardRef(
  (_a, ref) => {
    var _b = _a, { className, variant, size, asChild = false } = _b, props = __objRest(_b, ["className", "variant", "size", "asChild"]);
    const Comp = asChild ? Slot : "button";
    return /* @__PURE__ */ jsx3(
      Comp,
      __spreadValues({
        className: cn(buttonVariants({ variant, size, className })),
        ref
      }, props)
    );
  }
);
Button.displayName = "Button";

// src/components/alert-dialog/alert-dialog.tsx
import { jsx as jsx4, jsxs as jsxs2 } from "react/jsx-runtime";
var AlertDialog = AlertDialogPrimitive.Root;
var AlertDialogTrigger = AlertDialogPrimitive.Trigger;
var AlertDialogPortal = AlertDialogPrimitive.Portal;
var AlertDialogOverlay = React4.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx4(
    AlertDialogPrimitive.Overlay,
    __spreadProps(__spreadValues({
      className: cn(
        "fixed inset-0 z-50 bg-background/80 backdrop-blur-sm data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
        className
      )
    }, props), {
      ref
    })
  );
});
AlertDialogOverlay.displayName = AlertDialogPrimitive.Overlay.displayName;
var AlertDialogContent = React4.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsxs2(AlertDialogPortal, { children: [
    /* @__PURE__ */ jsx4(AlertDialogOverlay, {}),
    /* @__PURE__ */ jsx4(
      AlertDialogPrimitive.Content,
      __spreadValues({
        ref,
        className: cn(
          "fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border bg-card p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-lg",
          className
        )
      }, props)
    )
  ] });
});
AlertDialogContent.displayName = AlertDialogPrimitive.Content.displayName;
var AlertDialogHeader = (_a) => {
  var _b = _a, {
    className
  } = _b, props = __objRest(_b, [
    "className"
  ]);
  return /* @__PURE__ */ jsx4(
    "div",
    __spreadValues({
      className: cn(
        "flex flex-col space-y-2 text-center sm:text-left",
        className
      )
    }, props)
  );
};
AlertDialogHeader.displayName = "AlertDialogHeader";
var AlertDialogFooter = (_a) => {
  var _b = _a, {
    className
  } = _b, props = __objRest(_b, [
    "className"
  ]);
  return /* @__PURE__ */ jsx4(
    "div",
    __spreadValues({
      className: cn(
        "flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2",
        className
      )
    }, props)
  );
};
AlertDialogFooter.displayName = "AlertDialogFooter";
var AlertDialogTitle = React4.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx4(
    AlertDialogPrimitive.Title,
    __spreadValues({
      ref,
      className: cn("text-lg font-semibold", className)
    }, props)
  );
});
AlertDialogTitle.displayName = AlertDialogPrimitive.Title.displayName;
var AlertDialogDescription = React4.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx4(
    AlertDialogPrimitive.Description,
    __spreadValues({
      ref,
      className: cn("text-sm text-muted-foreground", className)
    }, props)
  );
});
AlertDialogDescription.displayName = AlertDialogPrimitive.Description.displayName;
var AlertDialogAction = React4.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx4(
    AlertDialogPrimitive.Action,
    __spreadValues({
      ref,
      className: cn(buttonVariants(), className)
    }, props)
  );
});
AlertDialogAction.displayName = AlertDialogPrimitive.Action.displayName;
var AlertDialogCancel = React4.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx4(
    AlertDialogPrimitive.Cancel,
    __spreadValues({
      ref,
      className: cn(
        buttonVariants({ variant: "outline" }),
        "mt-2 sm:mt-0",
        className
      )
    }, props)
  );
});
AlertDialogCancel.displayName = AlertDialogPrimitive.Cancel.displayName;

// src/components/badge/badge.tsx
import { cva as cva2 } from "class-variance-authority";
import { jsx as jsx5 } from "react/jsx-runtime";
var badgeVariants = cva2(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary: "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive: "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-foreground"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
);
function Badge(_a) {
  var _b = _a, { className, variant } = _b, props = __objRest(_b, ["className", "variant"]);
  return /* @__PURE__ */ jsx5("div", __spreadValues({ className: cn(badgeVariants({ variant }), className) }, props));
}

// src/components/breadcrumbs/breadcrumbs.tsx
import { Slot as Slot2 } from "@radix-ui/react-slot";
import { ChevronRight, MoreHorizontal } from "lucide-react";
import { forwardRef as forwardRef5 } from "react";
import { jsx as jsx6, jsxs as jsxs3 } from "react/jsx-runtime";
var Breadcrumb = forwardRef5((_a, ref) => {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ jsx6("nav", __spreadValues({ ref, "aria-label": "breadcrumb" }, props));
});
Breadcrumb.displayName = "Breadcrumb";
var BreadcrumbList = forwardRef5((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx6(
    "ol",
    __spreadValues({
      ref,
      className: cn(
        "flex flex-wrap items-center gap-1.5 break-words text-sm text-muted-foreground sm:gap-2.5",
        className
      )
    }, props)
  );
});
BreadcrumbList.displayName = "BreadcrumbList";
var BreadcrumbItem = forwardRef5((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx6(
    "li",
    __spreadValues({
      ref,
      className: cn("inline-flex items-center gap-1.5", className)
    }, props)
  );
});
BreadcrumbItem.displayName = "BreadcrumbItem";
var BreadcrumbLink = forwardRef5((_a, ref) => {
  var _b = _a, { asChild, className } = _b, props = __objRest(_b, ["asChild", "className"]);
  const Comp = asChild ? Slot2 : "a";
  return /* @__PURE__ */ jsx6(
    Comp,
    __spreadValues({
      ref,
      className: cn("transition-colors hover:text-foreground", className)
    }, props)
  );
});
BreadcrumbLink.displayName = "BreadcrumbLink";
var BreadcrumbPage = forwardRef5((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx6(
    "span",
    __spreadValues({
      ref,
      role: "link",
      "aria-disabled": "true",
      "aria-current": "page",
      className: cn("font-normal text-foreground", className)
    }, props)
  );
});
BreadcrumbPage.displayName = "BreadcrumbPage";
var BreadcrumbSeparator = (_a) => {
  var _b = _a, {
    children,
    className
  } = _b, props = __objRest(_b, [
    "children",
    "className"
  ]);
  return /* @__PURE__ */ jsx6(
    "li",
    __spreadProps(__spreadValues({
      role: "presentation",
      "aria-hidden": "true",
      className: cn("[&>svg]:size-3.5", className)
    }, props), {
      children: children != null ? children : /* @__PURE__ */ jsx6(ChevronRight, {})
    })
  );
};
BreadcrumbSeparator.displayName = "BreadcrumbSeparator";
var BreadcrumbEllipsis = (_a) => {
  var _b = _a, {
    className
  } = _b, props = __objRest(_b, [
    "className"
  ]);
  return /* @__PURE__ */ jsxs3(
    "span",
    __spreadProps(__spreadValues({
      role: "presentation",
      "aria-hidden": "true",
      className: cn("flex h-9 w-9 items-center justify-center", className)
    }, props), {
      children: [
        /* @__PURE__ */ jsx6(MoreHorizontal, { className: "h-4 w-4" }),
        /* @__PURE__ */ jsx6("span", { className: "sr-only", children: "More" })
      ]
    })
  );
};
BreadcrumbEllipsis.displayName = "BreadcrumbElipssis";

// src/components/card/card.tsx
import * as React5 from "react";
import { jsx as jsx7 } from "react/jsx-runtime";
var Card = React5.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx7(
    "div",
    __spreadValues({
      ref,
      className: cn(
        "rounded-lg border bg-card text-card-foreground shadow-sm",
        className
      )
    }, props)
  );
});
Card.displayName = "Card";
var CardHeader = React5.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx7(
    "div",
    __spreadValues({
      ref,
      className: cn("flex flex-col space-y-1.5 p-6", className)
    }, props)
  );
});
CardHeader.displayName = "CardHeader";
var CardTitle = React5.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return (
    // eslint-disable-next-line jsx-a11y/heading-has-content
    /* @__PURE__ */ jsx7(
      "h3",
      __spreadValues({
        ref,
        className: cn(
          "text-2xl font-semibold leading-none tracking-tight",
          className
        )
      }, props)
    )
  );
});
CardTitle.displayName = "CardTitle";
var CardDescription = React5.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx7(
    "p",
    __spreadValues({
      ref,
      className: cn("text-sm text-muted-foreground", className)
    }, props)
  );
});
CardDescription.displayName = "CardDescription";
var CardContent = React5.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx7("div", __spreadValues({ ref, className: cn("p-6 pt-0", className) }, props));
});
CardContent.displayName = "CardContent";
var CardFooter = React5.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx7(
    "div",
    __spreadValues({
      ref,
      className: cn("flex items-center p-6 pt-0", className)
    }, props)
  );
});
CardFooter.displayName = "CardFooter";

// src/components/calendar/calendar.tsx
import { ChevronLeft, ChevronRight as ChevronRight2 } from "lucide-react";
import { DayPicker } from "react-day-picker";
import { jsx as jsx8 } from "react/jsx-runtime";
function Calendar(_a) {
  var _b = _a, {
    className,
    classNames,
    showOutsideDays = true
  } = _b, props = __objRest(_b, [
    "className",
    "classNames",
    "showOutsideDays"
  ]);
  return /* @__PURE__ */ jsx8(
    DayPicker,
    __spreadValues({
      showOutsideDays,
      className: cn("p-3", className),
      classNames: __spreadValues({
        months: "flex flex-col sm:flex-row space-y-4 sm:space-x-4 sm:space-y-0",
        month: "space-y-4",
        caption: "flex justify-center pt-1 relative items-center",
        caption_label: "text-sm font-medium",
        nav: "space-x-1 flex items-center",
        nav_button: cn(
          buttonVariants({ variant: "outline" }),
          "h-7 w-7 bg-transparent p-0 opacity-50 hover:opacity-100"
        ),
        nav_button_previous: "absolute left-1",
        nav_button_next: "absolute right-1",
        table: "w-full border-collapse space-y-1",
        head_row: "flex",
        head_cell: "text-muted-foreground rounded-md w-9 font-normal text-[0.8rem]",
        row: "flex w-full mt-2",
        cell: "h-9 w-9 text-center text-sm p-0 relative [&:has([aria-selected].day-range-end)]:rounded-r-md [&:has([aria-selected].day-outside)]:bg-accent/50 [&:has([aria-selected])]:bg-accent first:[&:has([aria-selected])]:rounded-l-md last:[&:has([aria-selected])]:rounded-r-md focus-within:relative focus-within:z-20",
        day: cn(
          buttonVariants({ variant: "ghost" }),
          "h-9 w-9 p-0 font-normal aria-selected:opacity-100"
        ),
        day_range_end: "day-range-end",
        day_selected: "bg-primary text-primary-foreground hover:bg-primary hover:text-primary-foreground focus:bg-primary focus:text-primary-foreground",
        day_today: "bg-accent text-accent-foreground",
        day_outside: "day-outside text-muted-foreground opacity-50 aria-selected:bg-accent/50 aria-selected:text-muted-foreground aria-selected:opacity-30",
        day_disabled: "text-muted-foreground opacity-50",
        day_range_middle: "aria-selected:bg-accent aria-selected:text-accent-foreground",
        day_hidden: "invisible"
      }, classNames),
      components: {
        IconLeft: (_a2) => {
          var props2 = __objRest(_a2, []);
          return /* @__PURE__ */ jsx8(ChevronLeft, { className: "h-4 w-4" });
        },
        IconRight: (_b2) => {
          var props2 = __objRest(_b2, []);
          return /* @__PURE__ */ jsx8(ChevronRight2, { className: "h-4 w-4" });
        }
      }
    }, props)
  );
}
Calendar.displayName = "Calendar";

// src/components/calendar/index.ts
import { format } from "date-fns";

// src/components/checkbox/checkbox.tsx
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { Check } from "lucide-react";
import * as React6 from "react";
import { jsx as jsx9 } from "react/jsx-runtime";
var Checkbox = React6.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx9(
    CheckboxPrimitive.Root,
    __spreadProps(__spreadValues({
      ref,
      className: cn(
        "peer h-4 w-4 shrink-0 rounded-sm border border-primary ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground",
        className
      )
    }, props), {
      children: /* @__PURE__ */ jsx9(
        CheckboxPrimitive.Indicator,
        {
          className: cn("flex items-center justify-center text-current"),
          children: /* @__PURE__ */ jsx9(Check, { className: "h-4 w-4" })
        }
      )
    })
  );
});
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

// src/components/collapsible/collapsible.tsx
import * as CollapsiblePrimitive from "@radix-ui/react-collapsible";
var Collapsible = CollapsiblePrimitive.Root;
var { CollapsibleTrigger } = CollapsiblePrimitive;
var { CollapsibleContent } = CollapsiblePrimitive;

// src/components/command/command.tsx
import { Command as CommandPrimitive } from "cmdk";
import { Search } from "lucide-react";
import * as React8 from "react";

// src/components/dialog/dialog.tsx
import * as DialogPrimitive from "@radix-ui/react-dialog";
import { X } from "lucide-react";
import * as React7 from "react";
import { jsx as jsx10, jsxs as jsxs4 } from "react/jsx-runtime";
var Dialog = DialogPrimitive.Root;
var DialogTrigger = DialogPrimitive.Trigger;
var DialogPortal = DialogPrimitive.Portal;
var DialogClose = DialogPrimitive.Close;
var DialogOverlay = React7.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx10(
    DialogPrimitive.Overlay,
    __spreadValues({
      ref,
      className: cn(
        "fixed inset-0 z-50 bg-background/80 backdrop-blur-sm data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
        className
      )
    }, props)
  );
});
DialogOverlay.displayName = DialogPrimitive.Overlay.displayName;
var DialogContent = React7.forwardRef((_a, ref) => {
  var _b = _a, { className, children } = _b, props = __objRest(_b, ["className", "children"]);
  return /* @__PURE__ */ jsxs4(DialogPortal, { children: [
    /* @__PURE__ */ jsx10(DialogOverlay, {}),
    /* @__PURE__ */ jsxs4(
      DialogPrimitive.Content,
      __spreadProps(__spreadValues({
        ref,
        className: cn(
          "fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border bg-card p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-lg",
          className
        )
      }, props), {
        children: [
          children,
          /* @__PURE__ */ jsxs4(DialogPrimitive.Close, { className: "absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground", children: [
            /* @__PURE__ */ jsx10(X, { className: "h-4 w-4" }),
            /* @__PURE__ */ jsx10("span", { className: "sr-only", children: "Close" })
          ] })
        ]
      })
    )
  ] });
});
DialogContent.displayName = DialogPrimitive.Content.displayName;
var DialogHeader = (_a) => {
  var _b = _a, {
    className
  } = _b, props = __objRest(_b, [
    "className"
  ]);
  return /* @__PURE__ */ jsx10(
    "div",
    __spreadValues({
      className: cn(
        "flex flex-col space-y-1.5 text-center sm:text-left",
        className
      )
    }, props)
  );
};
DialogHeader.displayName = "DialogHeader";
var DialogFooter = (_a) => {
  var _b = _a, {
    className
  } = _b, props = __objRest(_b, [
    "className"
  ]);
  return /* @__PURE__ */ jsx10(
    "div",
    __spreadValues({
      className: cn(
        "flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2",
        className
      )
    }, props)
  );
};
DialogFooter.displayName = "DialogFooter";
var DialogTitle = React7.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx10(
    DialogPrimitive.Title,
    __spreadValues({
      ref,
      className: cn(
        "text-lg font-semibold leading-none tracking-tight",
        className
      )
    }, props)
  );
});
DialogTitle.displayName = DialogPrimitive.Title.displayName;
var DialogDescription = React7.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx10(
    DialogPrimitive.Description,
    __spreadValues({
      ref,
      className: cn("text-sm text-muted-foreground", className)
    }, props)
  );
});
DialogDescription.displayName = DialogPrimitive.Description.displayName;

// src/components/command/command.tsx
import { useDebouncedCallback } from "use-debounce";
import { jsx as jsx11, jsxs as jsxs5 } from "react/jsx-runtime";
var Command = React8.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx11(
    CommandPrimitive,
    __spreadValues({
      ref,
      className: cn(
        "flex h-full w-full flex-col overflow-hidden rounded-md bg-popover text-popover-foreground",
        className
      )
    }, props)
  );
});
Command.displayName = CommandPrimitive.displayName;
var CommandDialog = (_a) => {
  var _b = _a, { children } = _b, props = __objRest(_b, ["children"]);
  return /* @__PURE__ */ jsx11(Dialog, __spreadProps(__spreadValues({}, props), { children: /* @__PURE__ */ jsx11(DialogContent, { className: "overflow-hidden p-0 shadow-lg data-[state=closed]:slide-out-to-top-[8%] data-[state=open]:slide-in-from-top-[8%] top-[10%] -translate-y-[10%]", children: /* @__PURE__ */ jsx11(Command, { className: "[&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-muted-foreground [&_[cmdk-group]:not([hidden])_~[cmdk-group]]:pt-0 [&_[cmdk-group]]:px-2 [&_[cmdk-input-wrapper]_svg]:h-5 [&_[cmdk-input-wrapper]_svg]:w-5 [&_[cmdk-input]]:h-12 [&_[cmdk-item]]:px-2 [&_[cmdk-item]]:py-3 [&_[cmdk-item]_svg]:h-5 [&_[cmdk-item]_svg]:w-5", children }) }) }));
};
var CommandInput = React8.forwardRef((_a, ref) => {
  var _b = _a, { className, onValueChange, onInputChange, debounceDelay } = _b, props = __objRest(_b, ["className", "onValueChange", "onInputChange", "debounceDelay"]);
  const debounce = useDebouncedCallback((targetValue) => {
    onInputChange == null ? void 0 : onInputChange(targetValue);
  }, debounceDelay || 0);
  const handleInput = (event) => {
    const value = event.currentTarget.value;
    onValueChange == null ? void 0 : onValueChange(value);
    debounce(value);
  };
  return /* @__PURE__ */ jsxs5("div", { className: "flex items-center border-b px-3", "cmdk-input-wrapper": "", children: [
    /* @__PURE__ */ jsx11(Search, { className: "mr-2 h-4 w-4 shrink-0 opacity-50" }),
    /* @__PURE__ */ jsx11(
      CommandPrimitive.Input,
      __spreadProps(__spreadValues({
        ref,
        className: cn(
          "flex h-11 w-full rounded-md bg-transparent py-3 text-sm outline-none border-transparent focus:border-transparent focus:ring-0 placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50",
          className
        )
      }, props), {
        onInput: handleInput
      })
    )
  ] });
});
CommandInput.displayName = CommandPrimitive.Input.displayName;
var CommandList = React8.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx11(
    CommandPrimitive.List,
    __spreadValues({
      ref,
      className: cn("max-h-[300px] overflow-y-auto overflow-x-hidden", className)
    }, props)
  );
});
CommandList.displayName = CommandPrimitive.List.displayName;
var CommandEmpty = React8.forwardRef((props, ref) => /* @__PURE__ */ jsx11(
  CommandPrimitive.Empty,
  __spreadValues({
    ref,
    className: "py-6 text-center text-sm"
  }, props)
));
CommandEmpty.displayName = CommandPrimitive.Empty.displayName;
var CommandGroup = React8.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx11(
    CommandPrimitive.Group,
    __spreadValues({
      ref,
      className: cn(
        "overflow-hidden p-1 text-foreground [&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:py-1.5 [&_[cmdk-group-heading]]:text-xs [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-muted-foreground",
        className
      )
    }, props)
  );
});
CommandGroup.displayName = CommandPrimitive.Group.displayName;
var CommandSeparator = React8.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx11(
    CommandPrimitive.Separator,
    __spreadValues({
      ref,
      className: cn("-mx-1 h-px bg-border", className)
    }, props)
  );
});
CommandSeparator.displayName = CommandPrimitive.Separator.displayName;
var CommandItem = React8.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx11(
    CommandPrimitive.Item,
    __spreadValues({
      ref,
      className: cn(
        "relative flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none aria-selected:bg-accent aria-selected:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
        className
      )
    }, props)
  );
});
CommandItem.displayName = CommandPrimitive.Item.displayName;
var CommandShortcut = (_a) => {
  var _b = _a, {
    className
  } = _b, props = __objRest(_b, [
    "className"
  ]);
  return /* @__PURE__ */ jsx11(
    "span",
    __spreadValues({
      className: cn(
        "ml-auto text-xs tracking-widest text-muted-foreground",
        className
      )
    }, props)
  );
};
CommandShortcut.displayName = "CommandShortcut";

// src/components/dropdown-menu/dropdown-menu.tsx
import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu";
import { Check as Check2, ChevronRight as ChevronRight3, Circle } from "lucide-react";
import * as React9 from "react";
import { jsx as jsx12, jsxs as jsxs6 } from "react/jsx-runtime";
var DropdownMenu = DropdownMenuPrimitive.Root;
var DropdownMenuTrigger = DropdownMenuPrimitive.Trigger;
var DropdownMenuGroup = DropdownMenuPrimitive.Group;
var DropdownMenuPortal = DropdownMenuPrimitive.Portal;
var DropdownMenuSub = DropdownMenuPrimitive.Sub;
var DropdownMenuRadioGroup = DropdownMenuPrimitive.RadioGroup;
var DropdownMenuSubTrigger = React9.forwardRef((_a, ref) => {
  var _b = _a, { className, inset, children } = _b, props = __objRest(_b, ["className", "inset", "children"]);
  return /* @__PURE__ */ jsxs6(
    DropdownMenuPrimitive.SubTrigger,
    __spreadProps(__spreadValues({
      ref,
      className: cn(
        "flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none focus:bg-accent data-[state=open]:bg-accent",
        inset && "pl-8",
        className
      )
    }, props), {
      children: [
        children,
        /* @__PURE__ */ jsx12(ChevronRight3, { className: "ml-auto h-4 w-4" })
      ]
    })
  );
});
DropdownMenuSubTrigger.displayName = DropdownMenuPrimitive.SubTrigger.displayName;
var DropdownMenuSubContent = React9.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx12(
    DropdownMenuPrimitive.SubContent,
    __spreadValues({
      ref,
      className: cn(
        "z-50 min-w-[8rem] overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-lg data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
        className
      )
    }, props)
  );
});
DropdownMenuSubContent.displayName = DropdownMenuPrimitive.SubContent.displayName;
var DropdownMenuContent = React9.forwardRef((_a, ref) => {
  var _b = _a, { className, sideOffset = 4 } = _b, props = __objRest(_b, ["className", "sideOffset"]);
  return /* @__PURE__ */ jsx12(DropdownMenuPrimitive.Portal, { children: /* @__PURE__ */ jsx12(
    DropdownMenuPrimitive.Content,
    __spreadValues({
      ref,
      sideOffset,
      className: cn(
        "z-50 min-w-[8rem] overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
        className
      )
    }, props)
  ) });
});
DropdownMenuContent.displayName = DropdownMenuPrimitive.Content.displayName;
var DropdownMenuItem = React9.forwardRef((_a, ref) => {
  var _b = _a, { className, inset } = _b, props = __objRest(_b, ["className", "inset"]);
  return /* @__PURE__ */ jsx12(
    DropdownMenuPrimitive.Item,
    __spreadValues({
      ref,
      className: cn(
        "relative flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
        inset && "pl-8",
        className
      )
    }, props)
  );
});
DropdownMenuItem.displayName = DropdownMenuPrimitive.Item.displayName;
var DropdownMenuCheckboxItem = React9.forwardRef((_a, ref) => {
  var _b = _a, { className, children, checked } = _b, props = __objRest(_b, ["className", "children", "checked"]);
  return /* @__PURE__ */ jsxs6(
    DropdownMenuPrimitive.CheckboxItem,
    __spreadProps(__spreadValues({
      ref,
      className: cn(
        "relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
        className
      ),
      checked
    }, props), {
      children: [
        /* @__PURE__ */ jsx12("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ jsx12(DropdownMenuPrimitive.ItemIndicator, { children: /* @__PURE__ */ jsx12(Check2, { className: "h-4 w-4" }) }) }),
        children
      ]
    })
  );
});
DropdownMenuCheckboxItem.displayName = DropdownMenuPrimitive.CheckboxItem.displayName;
var DropdownMenuRadioItem = React9.forwardRef((_a, ref) => {
  var _b = _a, { className, children } = _b, props = __objRest(_b, ["className", "children"]);
  return /* @__PURE__ */ jsxs6(
    DropdownMenuPrimitive.RadioItem,
    __spreadProps(__spreadValues({
      ref,
      className: cn(
        "relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
        className
      )
    }, props), {
      children: [
        /* @__PURE__ */ jsx12("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ jsx12(DropdownMenuPrimitive.ItemIndicator, { children: /* @__PURE__ */ jsx12(Circle, { className: "h-2 w-2 fill-current" }) }) }),
        children
      ]
    })
  );
});
DropdownMenuRadioItem.displayName = DropdownMenuPrimitive.RadioItem.displayName;
var DropdownMenuLabel = React9.forwardRef((_a, ref) => {
  var _b = _a, { className, inset } = _b, props = __objRest(_b, ["className", "inset"]);
  return /* @__PURE__ */ jsx12(
    DropdownMenuPrimitive.Label,
    __spreadValues({
      ref,
      className: cn(
        "px-2 py-1.5 text-sm font-semibold",
        inset && "pl-8",
        className
      )
    }, props)
  );
});
DropdownMenuLabel.displayName = DropdownMenuPrimitive.Label.displayName;
var DropdownMenuSeparator = React9.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx12(
    DropdownMenuPrimitive.Separator,
    __spreadValues({
      ref,
      className: cn("-mx-1 my-1 h-px bg-muted", className)
    }, props)
  );
});
DropdownMenuSeparator.displayName = DropdownMenuPrimitive.Separator.displayName;
var DropdownMenuShortcut = (_a) => {
  var _b = _a, {
    className
  } = _b, props = __objRest(_b, [
    "className"
  ]);
  return /* @__PURE__ */ jsx12(
    "span",
    __spreadValues({
      className: cn("ml-auto text-xs tracking-widest opacity-60", className)
    }, props)
  );
};
DropdownMenuShortcut.displayName = "DropdownMenuShortcut";

// src/components/form/form.tsx
import { Slot as Slot3 } from "@radix-ui/react-slot";
import * as React11 from "react";
import { Controller, FormProvider, useFormContext } from "react-hook-form";

// src/components/label/label.tsx
import * as LabelPrimitive from "@radix-ui/react-label";
import { cva as cva3 } from "class-variance-authority";
import * as React10 from "react";
import { jsx as jsx13 } from "react/jsx-runtime";
var labelVariants = cva3(
  "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
);
var Label2 = React10.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx13(
    LabelPrimitive.Root,
    __spreadValues({
      ref,
      className: cn(labelVariants(), className)
    }, props)
  );
});
Label2.displayName = LabelPrimitive.Root.displayName;

// src/components/form/form.tsx
import { jsx as jsx14 } from "react/jsx-runtime";
var Form = FormProvider;
var FormFieldContext = React11.createContext(
  {}
);
var FormField = (_a) => {
  var props = __objRest(_a, []);
  return /* @__PURE__ */ jsx14(FormFieldContext.Provider, { value: { name: props.name }, children: /* @__PURE__ */ jsx14(Controller, __spreadValues({}, props)) });
};
var FormItemContext = React11.createContext(
  {}
);
var useFormField = () => {
  const fieldContext = React11.useContext(FormFieldContext);
  const itemContext = React11.useContext(FormItemContext);
  const { getFieldState, formState } = useFormContext();
  const fieldState = getFieldState(fieldContext.name, formState);
  if (!fieldContext) {
    throw new Error("useFormField should be used within <FormField>");
  }
  const { id } = itemContext;
  return __spreadValues({
    id,
    name: fieldContext.name,
    formItemId: `${id}-form-item`,
    formDescriptionId: `${id}-form-item-description`,
    formMessageId: `${id}-form-item-message`
  }, fieldState);
};
var FormItem = React11.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  const id = React11.useId();
  return /* @__PURE__ */ jsx14(FormItemContext.Provider, { value: { id }, children: /* @__PURE__ */ jsx14("div", __spreadValues({ ref, className: cn("space-y-2", className) }, props)) });
});
FormItem.displayName = "FormItem";
var FormLabel = React11.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  const { error, formItemId } = useFormField();
  return /* @__PURE__ */ jsx14(
    Label2,
    __spreadValues({
      ref,
      className: cn(error && "text-destructive", className),
      htmlFor: formItemId
    }, props)
  );
});
FormLabel.displayName = "FormLabel";
var FormControl = React11.forwardRef((_a, ref) => {
  var props = __objRest(_a, []);
  const { error, formItemId, formDescriptionId, formMessageId } = useFormField();
  return /* @__PURE__ */ jsx14(
    Slot3,
    __spreadValues({
      ref,
      id: formItemId,
      "aria-describedby": !error ? `${formDescriptionId}` : `${formDescriptionId} ${formMessageId}`,
      "aria-invalid": !!error
    }, props)
  );
});
FormControl.displayName = "FormControl";
var FormDescription = React11.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  const { formDescriptionId } = useFormField();
  return /* @__PURE__ */ jsx14(
    "p",
    __spreadValues({
      ref,
      id: formDescriptionId,
      className: cn("text-sm text-muted-foreground", className)
    }, props)
  );
});
FormDescription.displayName = "FormDescription";
var FormMessage = React11.forwardRef((_a, ref) => {
  var _b = _a, { className, children } = _b, props = __objRest(_b, ["className", "children"]);
  const { error, formMessageId } = useFormField();
  const body = error ? String(error == null ? void 0 : error.message) : children;
  if (!body) {
    return null;
  }
  return /* @__PURE__ */ jsx14(
    "p",
    __spreadProps(__spreadValues({
      ref,
      id: formMessageId,
      className: cn("text-sm font-medium text-destructive", className)
    }, props), {
      children: body
    })
  );
});
FormMessage.displayName = "FormMessage";

// src/components/hover-card/hover-card.tsx
import * as HoverCardPrimitive from "@radix-ui/react-hover-card";
import * as React12 from "react";
import { jsx as jsx15 } from "react/jsx-runtime";
var HoverCard = HoverCardPrimitive.Root;
var HoverCardTrigger = HoverCardPrimitive.Trigger;
var HoverCardContent = React12.forwardRef((_a, ref) => {
  var _b = _a, { className, align = "center", sideOffset = 4 } = _b, props = __objRest(_b, ["className", "align", "sideOffset"]);
  return /* @__PURE__ */ jsx15(
    HoverCardPrimitive.Content,
    __spreadValues({
      ref,
      align,
      sideOffset,
      className: cn(
        "z-50 w-64 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
        className
      )
    }, props)
  );
});
HoverCardContent.displayName = HoverCardPrimitive.Content.displayName;

// src/components/input/input.tsx
import { faEye, faEyeSlash } from "@fortawesome/pro-regular-svg-icons";
import * as React13 from "react";

// src/components/uturn-ui/icon/icon.tsx
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { jsx as jsx16 } from "react/jsx-runtime";
function Icon(props) {
  return /* @__PURE__ */ jsx16(FontAwesomeIcon, __spreadValues({}, props));
}

// src/components/uturn-ui/input-addon.tsx
import { jsx as jsx17 } from "react/jsx-runtime";
function InputAddon({
  children,
  type = "trailing",
  className
}) {
  return /* @__PURE__ */ jsx17(
    "div",
    {
      className: cn(
        "pointer-events-none absolute right-0 flex items-center h-10 bottom-0",
        type === "leading" ? "left-3" : "right-3",
        className
      ),
      children
    }
  );
}

// src/components/input/input.tsx
import { jsx as jsx18, jsxs as jsxs7 } from "react/jsx-runtime";
var Input = React13.forwardRef(
  (_a, ref) => {
    var _b = _a, { className, type } = _b, props = __objRest(_b, ["className", "type"]);
    const [showPassword, setShowPassword] = React13.useState(false);
    const determineType = () => {
      if (type === "password") {
        return showPassword ? "text" : "password";
      }
      return type;
    };
    const inputEl = /* @__PURE__ */ jsx18(
      "input",
      __spreadValues({
        type: determineType(),
        className: cn(
          "flex h-10 w-full rounded-md border border-input bg-transparent px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
          className,
          type === "password" && "password"
        ),
        ref
      }, props)
    );
    if (type === "password") {
      return /* @__PURE__ */ jsxs7("div", { className: "relative", children: [
        inputEl,
        /* @__PURE__ */ jsx18(InputAddon, { type: "trailing", className: "pointer-events-auto", children: /* @__PURE__ */ jsx18(
          "button",
          {
            type: "button",
            onClick: () => setShowPassword(!showPassword),
            children: /* @__PURE__ */ jsx18(
              Icon,
              {
                icon: showPassword ? faEyeSlash : faEye,
                className: "text-muted-foreground"
              }
            )
          }
        ) })
      ] });
    }
    return inputEl;
  }
);
Input.displayName = "Input";

// src/components/navigation-menu/navigation-menu.tsx
import * as NavigationMenuPrimitive from "@radix-ui/react-navigation-menu";
import { cva as cva4 } from "class-variance-authority";
import { ChevronDown as ChevronDown2 } from "lucide-react";
import * as React14 from "react";
import { jsx as jsx19, jsxs as jsxs8 } from "react/jsx-runtime";
var NavigationMenu = React14.forwardRef((_a, ref) => {
  var _b = _a, { className, children } = _b, props = __objRest(_b, ["className", "children"]);
  return /* @__PURE__ */ jsxs8(
    NavigationMenuPrimitive.Root,
    __spreadProps(__spreadValues({
      ref,
      className: cn(
        "relative z-10 flex max-w-max flex-1 items-center justify-center",
        className
      )
    }, props), {
      children: [
        children,
        /* @__PURE__ */ jsx19(NavigationMenuViewport, {})
      ]
    })
  );
});
NavigationMenu.displayName = NavigationMenuPrimitive.Root.displayName;
var NavigationMenuList = React14.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx19(
    NavigationMenuPrimitive.List,
    __spreadValues({
      ref,
      className: cn(
        "group flex flex-1 list-none items-center justify-center space-x-1",
        className
      )
    }, props)
  );
});
NavigationMenuList.displayName = NavigationMenuPrimitive.List.displayName;
var NavigationMenuItem = NavigationMenuPrimitive.Item;
var navigationMenuTriggerStyle = cva4(
  "group inline-flex h-10 w-max items-center justify-center rounded-md bg-background px-4 py-2 text-sm font-medium transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground focus:outline-none disabled:pointer-events-none disabled:opacity-50 data-[active]:bg-accent/50 data-[state=open]:bg-accent/50"
);
var NavigationMenuTrigger = React14.forwardRef((_a, ref) => {
  var _b = _a, { className, children } = _b, props = __objRest(_b, ["className", "children"]);
  return /* @__PURE__ */ jsxs8(
    NavigationMenuPrimitive.Trigger,
    __spreadProps(__spreadValues({
      ref,
      className: cn(navigationMenuTriggerStyle(), "group", className)
    }, props), {
      children: [
        children,
        " ",
        /* @__PURE__ */ jsx19(
          ChevronDown2,
          {
            className: "relative top-[1px] ml-1 h-3 w-3 transition duration-200 group-data-[state=open]:rotate-180",
            "aria-hidden": "true"
          }
        )
      ]
    })
  );
});
NavigationMenuTrigger.displayName = NavigationMenuPrimitive.Trigger.displayName;
var NavigationMenuContent = React14.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx19(
    NavigationMenuPrimitive.Content,
    __spreadValues({
      ref,
      className: cn(
        "left-0 top-0 w-full data-[motion^=from-]:animate-in data-[motion^=to-]:animate-out data-[motion^=from-]:fade-in data-[motion^=to-]:fade-out data-[motion=from-end]:slide-in-from-right-52 data-[motion=from-start]:slide-in-from-left-52 data-[motion=to-end]:slide-out-to-right-52 data-[motion=to-start]:slide-out-to-left-52 md:absolute md:w-auto ",
        className
      )
    }, props)
  );
});
NavigationMenuContent.displayName = NavigationMenuPrimitive.Content.displayName;
var NavigationMenuLink = NavigationMenuPrimitive.Link;
var NavigationMenuViewport = React14.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx19("div", { className: cn("absolute left-0 top-full flex justify-center"), children: /* @__PURE__ */ jsx19(
    NavigationMenuPrimitive.Viewport,
    __spreadValues({
      className: cn(
        "origin-top-center relative mt-1.5 h-[var(--radix-navigation-menu-viewport-height)] w-full overflow-hidden rounded-md border bg-popover text-popover-foreground shadow-lg data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-90 md:w-[var(--radix-navigation-menu-viewport-width)]",
        className
      ),
      ref
    }, props)
  ) });
});
NavigationMenuViewport.displayName = NavigationMenuPrimitive.Viewport.displayName;
var NavigationMenuIndicator = React14.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx19(
    NavigationMenuPrimitive.Indicator,
    __spreadProps(__spreadValues({
      ref,
      className: cn(
        "top-full z-[1] flex h-1.5 items-end justify-center overflow-hidden data-[state=visible]:animate-in data-[state=hidden]:animate-out data-[state=hidden]:fade-out data-[state=visible]:fade-in",
        className
      )
    }, props), {
      children: /* @__PURE__ */ jsx19("div", { className: "relative top-[60%] h-2 w-2 rotate-45 rounded-tl-sm bg-border shadow-md" })
    })
  );
});
NavigationMenuIndicator.displayName = NavigationMenuPrimitive.Indicator.displayName;

// src/components/popover/popover.tsx
import * as PopoverPrimitive from "@radix-ui/react-popover";
import * as React15 from "react";
import { jsx as jsx20 } from "react/jsx-runtime";
var Popover = PopoverPrimitive.Root;
var PopoverTrigger = PopoverPrimitive.Trigger;
var PopoverContent = React15.forwardRef((_a, ref) => {
  var _b = _a, { className, align = "center", sideOffset = 4 } = _b, props = __objRest(_b, ["className", "align", "sideOffset"]);
  return /* @__PURE__ */ jsx20(PopoverPrimitive.Portal, { children: /* @__PURE__ */ jsx20(
    PopoverPrimitive.Content,
    __spreadValues({
      ref,
      align,
      sideOffset,
      className: cn(
        "z-50 w-72 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
        className
      )
    }, props)
  ) });
});
PopoverContent.displayName = PopoverPrimitive.Content.displayName;

// src/components/radio-group/radio-group.tsx
import * as RadioGroupPrimitive from "@radix-ui/react-radio-group";
import { Circle as Circle2 } from "lucide-react";
import * as React16 from "react";
import { jsx as jsx21 } from "react/jsx-runtime";
var RadioGroup2 = React16.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx21(
    RadioGroupPrimitive.Root,
    __spreadProps(__spreadValues({
      className: cn("grid gap-2", className)
    }, props), {
      ref
    })
  );
});
RadioGroup2.displayName = RadioGroupPrimitive.Root.displayName;
var RadioGroupItem = React16.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx21(
    RadioGroupPrimitive.Item,
    __spreadProps(__spreadValues({
      ref,
      className: cn(
        "aspect-square h-4 w-4 rounded-full border border-primary text-primary ring-offset-background focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
        className
      )
    }, props), {
      children: /* @__PURE__ */ jsx21(RadioGroupPrimitive.Indicator, { className: "flex items-center justify-center", children: /* @__PURE__ */ jsx21(Circle2, { className: "h-2 w-2 fill-current text-current" }) })
    })
  );
});
RadioGroupItem.displayName = RadioGroupPrimitive.Item.displayName;

// src/components/scroll-area/scroll-area.tsx
import * as ScrollAreaPrimitive from "@radix-ui/react-scroll-area";
import * as React17 from "react";
import { jsx as jsx22, jsxs as jsxs9 } from "react/jsx-runtime";
var ScrollBar = React17.forwardRef((_a, ref) => {
  var _b = _a, { className, orientation = "vertical" } = _b, props = __objRest(_b, ["className", "orientation"]);
  return /* @__PURE__ */ jsx22(
    ScrollAreaPrimitive.ScrollAreaScrollbar,
    __spreadProps(__spreadValues({
      ref,
      orientation,
      className: cn(
        "flex touch-none select-none transition-colors",
        orientation === "vertical" && "h-full w-2.5 border-l border-l-transparent p-[1px]",
        orientation === "horizontal" && "h-2.5 flex-col border-t border-t-transparent p-[1px]",
        className
      )
    }, props), {
      children: /* @__PURE__ */ jsx22(ScrollAreaPrimitive.ScrollAreaThumb, { className: "relative flex-1 rounded-full bg-border" })
    })
  );
});
ScrollBar.displayName = ScrollAreaPrimitive.ScrollAreaScrollbar.displayName;
var ScrollArea = React17.forwardRef((_a, ref) => {
  var _b = _a, { className, children } = _b, props = __objRest(_b, ["className", "children"]);
  return /* @__PURE__ */ jsxs9(
    ScrollAreaPrimitive.Root,
    __spreadProps(__spreadValues({
      ref,
      className: cn("relative overflow-hidden", className)
    }, props), {
      children: [
        /* @__PURE__ */ jsx22(ScrollAreaPrimitive.Viewport, { className: "h-full w-full rounded-[inherit]", children }),
        /* @__PURE__ */ jsx22(ScrollBar, {}),
        /* @__PURE__ */ jsx22(ScrollAreaPrimitive.Corner, {})
      ]
    })
  );
});
ScrollArea.displayName = ScrollAreaPrimitive.Root.displayName;

// src/components/select/select.tsx
import * as SelectPrimitive from "@radix-ui/react-select";
import { Check as Check3, ChevronDown as ChevronDown3, ChevronUp } from "lucide-react";
import * as React18 from "react";
import { jsx as jsx23, jsxs as jsxs10 } from "react/jsx-runtime";
var Select = SelectPrimitive.Root;
var SelectGroup = SelectPrimitive.Group;
var SelectValue = SelectPrimitive.Value;
var SelectTrigger = React18.forwardRef((_a, ref) => {
  var _b = _a, { className, children } = _b, props = __objRest(_b, ["className", "children"]);
  return /* @__PURE__ */ jsxs10(
    SelectPrimitive.Trigger,
    __spreadProps(__spreadValues({
      ref,
      className: cn(
        "flex h-10 w-full items-center justify-between rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 [&>span]:line-clamp-1",
        className
      )
    }, props), {
      children: [
        children,
        /* @__PURE__ */ jsx23(SelectPrimitive.Icon, { asChild: true, children: /* @__PURE__ */ jsx23(ChevronDown3, { className: "h-4 w-4 opacity-50" }) })
      ]
    })
  );
});
SelectTrigger.displayName = SelectPrimitive.Trigger.displayName;
var SelectScrollUpButton = React18.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx23(
    SelectPrimitive.ScrollUpButton,
    __spreadProps(__spreadValues({
      ref,
      className: cn(
        "flex cursor-default items-center justify-center py-1",
        className
      )
    }, props), {
      children: /* @__PURE__ */ jsx23(ChevronUp, { className: "h-4 w-4" })
    })
  );
});
SelectScrollUpButton.displayName = SelectPrimitive.ScrollUpButton.displayName;
var SelectScrollDownButton = React18.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx23(
    SelectPrimitive.ScrollDownButton,
    __spreadProps(__spreadValues({
      ref,
      className: cn(
        "flex cursor-default items-center justify-center py-1",
        className
      )
    }, props), {
      children: /* @__PURE__ */ jsx23(ChevronDown3, { className: "h-4 w-4" })
    })
  );
});
SelectScrollDownButton.displayName = SelectPrimitive.ScrollDownButton.displayName;
var SelectContent = React18.forwardRef((_a, ref) => {
  var _b = _a, { className, children, position = "popper" } = _b, props = __objRest(_b, ["className", "children", "position"]);
  return /* @__PURE__ */ jsx23(SelectPrimitive.Portal, { children: /* @__PURE__ */ jsxs10(
    SelectPrimitive.Content,
    __spreadProps(__spreadValues({
      ref,
      className: cn(
        "relative z-50 max-h-96 min-w-[8rem] overflow-hidden rounded-md border bg-popover text-popover-foreground shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
        position === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1",
        className
      ),
      position
    }, props), {
      children: [
        /* @__PURE__ */ jsx23(SelectScrollUpButton, {}),
        /* @__PURE__ */ jsx23(
          SelectPrimitive.Viewport,
          {
            className: cn(
              "p-1",
              position === "popper" && "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)]"
            ),
            children
          }
        ),
        /* @__PURE__ */ jsx23(SelectScrollDownButton, {})
      ]
    })
  ) });
});
SelectContent.displayName = SelectPrimitive.Content.displayName;
var SelectLabel = React18.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx23(
    SelectPrimitive.Label,
    __spreadValues({
      ref,
      className: cn("py-1.5 pl-8 pr-2 text-sm font-semibold", className)
    }, props)
  );
});
SelectLabel.displayName = SelectPrimitive.Label.displayName;
var SelectItem = React18.forwardRef((_a, ref) => {
  var _b = _a, { className, children } = _b, props = __objRest(_b, ["className", "children"]);
  return /* @__PURE__ */ jsxs10(
    SelectPrimitive.Item,
    __spreadProps(__spreadValues({
      ref,
      className: cn(
        "relative flex w-full cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
        className
      )
    }, props), {
      children: [
        /* @__PURE__ */ jsx23("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ jsx23(SelectPrimitive.ItemIndicator, { children: /* @__PURE__ */ jsx23(Check3, { className: "h-4 w-4" }) }) }),
        /* @__PURE__ */ jsx23(SelectPrimitive.ItemText, { children })
      ]
    })
  );
});
SelectItem.displayName = SelectPrimitive.Item.displayName;
var SelectSeparator = React18.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx23(
    SelectPrimitive.Separator,
    __spreadValues({
      ref,
      className: cn("-mx-1 my-1 h-px bg-muted", className)
    }, props)
  );
});
SelectSeparator.displayName = SelectPrimitive.Separator.displayName;

// src/components/seperator/separator.tsx
import * as SeparatorPrimitive from "@radix-ui/react-separator";
import * as React19 from "react";
import { jsx as jsx24 } from "react/jsx-runtime";
var Separator3 = React19.forwardRef(
  (_a, ref) => {
    var _b = _a, { className, orientation = "horizontal", decorative = true } = _b, props = __objRest(_b, ["className", "orientation", "decorative"]);
    return /* @__PURE__ */ jsx24(
      SeparatorPrimitive.Root,
      __spreadValues({
        ref,
        decorative,
        orientation,
        className: cn(
          "shrink-0 bg-border",
          orientation === "horizontal" ? "h-[1px] w-full" : "h-full w-[1px]",
          className
        )
      }, props)
    );
  }
);
Separator3.displayName = SeparatorPrimitive.Root.displayName;

// src/components/sheet/sheet.tsx
import * as SheetPrimitive from "@radix-ui/react-dialog";
import { cva as cva5 } from "class-variance-authority";
import { X as X2 } from "lucide-react";
import * as React20 from "react";
import { jsx as jsx25, jsxs as jsxs11 } from "react/jsx-runtime";
var Sheet = SheetPrimitive.Root;
var SheetTrigger = SheetPrimitive.Trigger;
var SheetClose = SheetPrimitive.Close;
var SheetPortal = SheetPrimitive.Portal;
var SheetOverlay = React20.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx25(
    SheetPrimitive.Overlay,
    __spreadProps(__spreadValues({
      className: cn(
        "fixed inset-0 z-50 bg-background/80 backdrop-blur-sm data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
        className
      )
    }, props), {
      ref
    })
  );
});
SheetOverlay.displayName = SheetPrimitive.Overlay.displayName;
var sheetVariants = cva5(
  "fixed z-50 gap-4 bg-card p-6 shadow-lg transition ease-in-out data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:duration-300 data-[state=open]:duration-500",
  {
    variants: {
      side: {
        top: "inset-x-0 top-0 border-b data-[state=closed]:slide-out-to-top data-[state=open]:slide-in-from-top",
        bottom: "inset-x-0 bottom-0 border-t data-[state=closed]:slide-out-to-bottom data-[state=open]:slide-in-from-bottom",
        left: "inset-y-0 left-0 h-full w-3/4 border-r data-[state=closed]:slide-out-to-left data-[state=open]:slide-in-from-left sm:max-w-md",
        right: "inset-y-0 right-0 h-full w-3/4  border-l data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right sm:max-w-md"
      }
    },
    defaultVariants: {
      side: "right"
    }
  }
);
var SheetContent = React20.forwardRef((_a, ref) => {
  var _b = _a, { side = "right", className, children } = _b, props = __objRest(_b, ["side", "className", "children"]);
  return /* @__PURE__ */ jsxs11(SheetPortal, { children: [
    /* @__PURE__ */ jsx25(SheetOverlay, {}),
    /* @__PURE__ */ jsxs11(
      SheetPrimitive.Content,
      __spreadProps(__spreadValues({
        ref,
        className: cn(sheetVariants({ side }), className)
      }, props), {
        children: [
          children,
          /* @__PURE__ */ jsxs11(SheetPrimitive.Close, { className: "absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-secondary", children: [
            /* @__PURE__ */ jsx25(X2, { className: "h-4 w-4" }),
            /* @__PURE__ */ jsx25("span", { className: "sr-only", children: "Close" })
          ] })
        ]
      })
    )
  ] });
});
SheetContent.displayName = SheetPrimitive.Content.displayName;
var SheetHeader = (_a) => {
  var _b = _a, {
    className
  } = _b, props = __objRest(_b, [
    "className"
  ]);
  return /* @__PURE__ */ jsx25(
    "div",
    __spreadValues({
      className: cn(
        "flex flex-col space-y-2 text-center sm:text-left",
        className
      )
    }, props)
  );
};
SheetHeader.displayName = "SheetHeader";
var SheetFooter = (_a) => {
  var _b = _a, {
    className
  } = _b, props = __objRest(_b, [
    "className"
  ]);
  return /* @__PURE__ */ jsx25(
    "div",
    __spreadValues({
      className: cn(
        "flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2",
        className
      )
    }, props)
  );
};
SheetFooter.displayName = "SheetFooter";
var SheetTitle = React20.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx25(
    SheetPrimitive.Title,
    __spreadValues({
      ref,
      className: cn("text-lg font-semibold text-foreground", className)
    }, props)
  );
});
SheetTitle.displayName = SheetPrimitive.Title.displayName;
var SheetDescription = React20.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx25(
    SheetPrimitive.Description,
    __spreadValues({
      ref,
      className: cn("text-sm text-muted-foreground", className)
    }, props)
  );
});
SheetDescription.displayName = SheetPrimitive.Description.displayName;

// src/components/skeleton/skeleton.tsx
import { jsx as jsx26 } from "react/jsx-runtime";
function Skeleton(_a) {
  var _b = _a, {
    className
  } = _b, props = __objRest(_b, [
    "className"
  ]);
  return /* @__PURE__ */ jsx26(
    "div",
    __spreadValues({
      className: cn("animate-pulse rounded-md bg-muted", className)
    }, props)
  );
}

// src/components/switch/switch.tsx
import * as SwitchPrimitives from "@radix-ui/react-switch";
import * as React21 from "react";
import { jsx as jsx27 } from "react/jsx-runtime";
var Switch = React21.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx27(
    SwitchPrimitives.Root,
    __spreadProps(__spreadValues({
      className: cn(
        "peer inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=unchecked]:bg-input",
        className
      )
    }, props), {
      ref,
      children: /* @__PURE__ */ jsx27(
        SwitchPrimitives.Thumb,
        {
          className: cn(
            "pointer-events-none block h-5 w-5 rounded-full bg-background shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0"
          )
        }
      )
    })
  );
});
Switch.displayName = SwitchPrimitives.Root.displayName;

// src/components/table/table.tsx
import * as React22 from "react";
import { jsx as jsx28 } from "react/jsx-runtime";
var Table = React22.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx28("div", { className: "relative w-full overflow-auto", children: /* @__PURE__ */ jsx28(
    "table",
    __spreadValues({
      ref,
      className: cn(
        "w-full caption-bottom text-sm bg-card rounded-md",
        className
      )
    }, props)
  ) });
});
Table.displayName = "Table";
var TableHeader = React22.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx28("thead", __spreadValues({ ref, className: cn("[&_tr]:border-b", className) }, props));
});
TableHeader.displayName = "TableHeader";
var TableBody = React22.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx28(
    "tbody",
    __spreadValues({
      ref,
      className: cn("[&_tr:last-child]:border-0", className)
    }, props)
  );
});
TableBody.displayName = "TableBody";
var TableFooter = React22.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx28(
    "tfoot",
    __spreadValues({
      ref,
      className: cn(
        "border-t bg-muted/50 font-medium [&>tr]:last:border-b-0",
        className
      )
    }, props)
  );
});
TableFooter.displayName = "TableFooter";
var TableRow = React22.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx28(
    "tr",
    __spreadValues({
      ref,
      className: cn(
        "border-b transition-colors hover:bg-muted/50 data-[state=selected]:bg-muted",
        className
      )
    }, props)
  );
});
TableRow.displayName = "TableRow";
var TableHead = React22.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx28(
    "th",
    __spreadValues({
      ref,
      className: cn(
        "h-12 px-4 text-left align-middle font-medium text-muted-foreground [&:has([role=checkbox])]:pr-0",
        className
      )
    }, props)
  );
});
TableHead.displayName = "TableHead";
var TableCell = React22.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx28(
    "td",
    __spreadValues({
      ref,
      className: cn("p-4 align-middle [&:has([role=checkbox])]:pr-0", className)
    }, props)
  );
});
TableCell.displayName = "TableCell";
var TableCaption = React22.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx28(
    "caption",
    __spreadValues({
      ref,
      className: cn("mt-4 text-sm text-muted-foreground", className)
    }, props)
  );
});
TableCaption.displayName = "TableCaption";

// src/components/tabs/tabs.tsx
import * as TabsPrimitive from "@radix-ui/react-tabs";
import * as React23 from "react";
import { jsx as jsx29 } from "react/jsx-runtime";
var Tabs = TabsPrimitive.Root;
var TabsList = React23.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx29(
    TabsPrimitive.List,
    __spreadValues({
      ref,
      className: cn(
        "inline-flex h-10 items-center justify-center rounded-md bg-muted p-1 text-muted-foreground",
        className
      )
    }, props)
  );
});
TabsList.displayName = TabsPrimitive.List.displayName;
var TabsTrigger = React23.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx29(
    TabsPrimitive.Trigger,
    __spreadValues({
      ref,
      className: cn(
        "inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-background data-[state=active]:text-foreground data-[state=active]:shadow-sm",
        className
      )
    }, props)
  );
});
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName;
var TabsContent = React23.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx29(
    TabsPrimitive.Content,
    __spreadValues({
      ref,
      className: cn(
        "mt-2 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
        className
      )
    }, props)
  );
});
TabsContent.displayName = TabsPrimitive.Content.displayName;

// src/components/textarea/textarea.tsx
import * as React24 from "react";
import { jsx as jsx30 } from "react/jsx-runtime";
var Textarea = React24.forwardRef(
  (_a, ref) => {
    var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
    return /* @__PURE__ */ jsx30(
      "textarea",
      __spreadValues({
        className: cn(
          "flex min-h-[80px] w-full rounded-md border border-input bg-transparent px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
          className
        ),
        ref
      }, props)
    );
  }
);
Textarea.displayName = "Textarea";

// src/components/toast/toast.tsx
import * as ToastPrimitives from "@radix-ui/react-toast";
import { cva as cva6 } from "class-variance-authority";
import { X as X3 } from "lucide-react";
import * as React25 from "react";
import { jsx as jsx31 } from "react/jsx-runtime";
var ToastProvider = ToastPrimitives.Provider;
var ToastViewport = React25.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx31(
    ToastPrimitives.Viewport,
    __spreadValues({
      ref,
      className: cn(
        "fixed top-0 z-[100] flex max-h-screen w-full flex-col-reverse p-4 sm:bottom-0 sm:right-0 sm:top-auto sm:flex-col md:max-w-[420px]",
        className
      )
    }, props)
  );
});
ToastViewport.displayName = ToastPrimitives.Viewport.displayName;
var toastVariants = cva6(
  "group pointer-events-auto relative flex w-full items-center justify-between space-x-4 overflow-hidden rounded-md border p-6 pr-8 shadow-lg transition-all data-[swipe=cancel]:translate-x-0 data-[swipe=end]:translate-x-[var(--radix-toast-swipe-end-x)] data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)] data-[swipe=move]:transition-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[swipe=end]:animate-out data-[state=closed]:fade-out-80 data-[state=closed]:slide-out-to-right-full data-[state=open]:slide-in-from-top-full data-[state=open]:sm:slide-in-from-bottom-full",
  {
    variants: {
      variant: {
        default: "border bg-card text-foreground",
        destructive: "destructive group border-destructive bg-destructive text-destructive-foreground"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
);
var Toast = React25.forwardRef((_a, ref) => {
  var _b = _a, { className, variant } = _b, props = __objRest(_b, ["className", "variant"]);
  return /* @__PURE__ */ jsx31(
    ToastPrimitives.Root,
    __spreadValues({
      ref,
      className: cn(toastVariants({ variant }), className)
    }, props)
  );
});
Toast.displayName = ToastPrimitives.Root.displayName;
var ToastAction = React25.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx31(
    ToastPrimitives.Action,
    __spreadValues({
      ref,
      className: cn(
        "inline-flex h-8 shrink-0 items-center justify-center rounded-md border bg-transparent px-3 text-sm font-medium ring-offset-background transition-colors hover:bg-secondary focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 group-[.destructive]:border-muted/40 group-[.destructive]:hover:border-destructive/30 group-[.destructive]:hover:bg-destructive group-[.destructive]:hover:text-destructive-foreground group-[.destructive]:focus:ring-destructive",
        className
      )
    }, props)
  );
});
ToastAction.displayName = ToastPrimitives.Action.displayName;
var ToastClose = React25.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx31(
    ToastPrimitives.Close,
    __spreadProps(__spreadValues({
      ref,
      className: cn(
        "absolute right-2 top-2 rounded-md p-1 text-foreground/50 opacity-0 transition-opacity hover:text-foreground focus:opacity-100 focus:outline-none focus:ring-2 group-hover:opacity-100 group-[.destructive]:text-red-300 group-[.destructive]:hover:text-red-50 group-[.destructive]:focus:ring-red-400 group-[.destructive]:focus:ring-offset-red-600",
        className
      ),
      "toast-close": ""
    }, props), {
      children: /* @__PURE__ */ jsx31(X3, { className: "h-4 w-4" })
    })
  );
});
ToastClose.displayName = ToastPrimitives.Close.displayName;
var ToastTitle = React25.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx31(
    ToastPrimitives.Title,
    __spreadValues({
      ref,
      className: cn("text-sm font-semibold", className)
    }, props)
  );
});
ToastTitle.displayName = ToastPrimitives.Title.displayName;
var ToastDescription = React25.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx31(
    ToastPrimitives.Description,
    __spreadValues({
      ref,
      className: cn("text-sm opacity-90", className)
    }, props)
  );
});
ToastDescription.displayName = ToastPrimitives.Description.displayName;

// src/components/toast/use-toast.ts
import * as React26 from "react";
var TOAST_LIMIT = 1;
var TOAST_REMOVE_DELAY = 1e6;
var count = 0;
function genId() {
  count = (count + 1) % Number.MAX_SAFE_INTEGER;
  return count.toString();
}
var toastTimeouts = /* @__PURE__ */ new Map();
var addToRemoveQueue = (toastId) => {
  if (toastTimeouts.has(toastId)) {
    return;
  }
  const timeout = setTimeout(() => {
    toastTimeouts.delete(toastId);
    dispatch({
      type: "REMOVE_TOAST",
      toastId
    });
  }, TOAST_REMOVE_DELAY);
  toastTimeouts.set(toastId, timeout);
};
var reducer = (state, action) => {
  switch (action.type) {
    case "ADD_TOAST":
      return __spreadProps(__spreadValues({}, state), {
        toasts: [action.toast, ...state.toasts].slice(0, TOAST_LIMIT)
      });
    case "UPDATE_TOAST":
      return __spreadProps(__spreadValues({}, state), {
        toasts: state.toasts.map(
          (t) => t.id === action.toast.id ? __spreadValues(__spreadValues({}, t), action.toast) : t
        )
      });
    case "DISMISS_TOAST": {
      const { toastId } = action;
      if (toastId) {
        addToRemoveQueue(toastId);
      } else {
        state.toasts.forEach((toast2) => {
          addToRemoveQueue(toast2.id);
        });
      }
      return __spreadProps(__spreadValues({}, state), {
        toasts: state.toasts.map(
          (t) => t.id === toastId || toastId === void 0 ? __spreadProps(__spreadValues({}, t), {
            open: false
          }) : t
        )
      });
    }
    case "REMOVE_TOAST":
      if (action.toastId === void 0) {
        return __spreadProps(__spreadValues({}, state), {
          toasts: []
        });
      }
      return __spreadProps(__spreadValues({}, state), {
        toasts: state.toasts.filter((t) => t.id !== action.toastId)
      });
    default:
      return state;
  }
};
var listeners = [];
var memoryState = { toasts: [] };
function dispatch(action) {
  memoryState = reducer(memoryState, action);
  listeners.forEach((listener) => {
    listener(memoryState);
  });
}
function toast(_a) {
  var props = __objRest(_a, []);
  const id = genId();
  const update = (props2) => dispatch({
    type: "UPDATE_TOAST",
    toast: __spreadProps(__spreadValues({}, props2), { id })
  });
  const dismiss = () => dispatch({ type: "DISMISS_TOAST", toastId: id });
  dispatch({
    type: "ADD_TOAST",
    toast: __spreadProps(__spreadValues({}, props), {
      id,
      open: true,
      onOpenChange: (open) => {
        if (!open)
          dismiss();
      }
    })
  });
  return {
    id,
    dismiss,
    update
  };
}
function useToast() {
  const [state, setState] = React26.useState(memoryState);
  React26.useEffect(() => {
    listeners.push(setState);
    return () => {
      const index = listeners.indexOf(setState);
      if (index > -1) {
        listeners.splice(index, 1);
      }
    };
  }, [state]);
  return __spreadProps(__spreadValues({}, state), {
    toast,
    dismiss: (toastId) => dispatch({ type: "DISMISS_TOAST", toastId })
  });
}

// src/components/toast/toaster.tsx
import { jsx as jsx32, jsxs as jsxs12 } from "react/jsx-runtime";
function Toaster() {
  const { toasts } = useToast();
  return /* @__PURE__ */ jsxs12(ToastProvider, { children: [
    toasts.map((_a) => {
      var _b = _a, { id, title, description, action } = _b, props = __objRest(_b, ["id", "title", "description", "action"]);
      return /* @__PURE__ */ jsxs12(Toast, __spreadProps(__spreadValues({}, props), { children: [
        /* @__PURE__ */ jsxs12("div", { className: "grid gap-1", children: [
          title && /* @__PURE__ */ jsx32(ToastTitle, { children: title }),
          description && /* @__PURE__ */ jsx32(ToastDescription, { children: description })
        ] }),
        action,
        /* @__PURE__ */ jsx32(ToastClose, {})
      ] }), id);
    }),
    /* @__PURE__ */ jsx32(ToastViewport, {})
  ] });
}

// src/components/tooltip/tooltip.tsx
import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import * as React27 from "react";
import { jsx as jsx33 } from "react/jsx-runtime";
var TooltipProvider = TooltipPrimitive.Provider;
var Tooltip = TooltipPrimitive.Root;
var TooltipTrigger = TooltipPrimitive.Trigger;
var TooltipContent = React27.forwardRef((_a, ref) => {
  var _b = _a, { className, sideOffset = 4 } = _b, props = __objRest(_b, ["className", "sideOffset"]);
  return /* @__PURE__ */ jsx33(
    TooltipPrimitive.Content,
    __spreadValues({
      ref,
      sideOffset,
      className: cn(
        "z-50 overflow-hidden rounded-md border bg-popover px-3 py-1.5 text-sm text-popover-foreground shadow-md animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
        className
      )
    }, props)
  );
});
TooltipContent.displayName = TooltipPrimitive.Content.displayName;

// src/components/pagination/pagination.tsx
import { ChevronLeft as ChevronLeft2, ChevronRight as ChevronRight4, MoreHorizontal as MoreHorizontal2 } from "lucide-react";
import * as React28 from "react";
import { jsx as jsx34, jsxs as jsxs13 } from "react/jsx-runtime";
var Pagination = (_a) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx34(
    "nav",
    __spreadValues({
      role: "navigation",
      "aria-label": "pagination",
      className: cn("mx-auto flex w-full justify-center py-4", className)
    }, props)
  );
};
Pagination.displayName = "Pagination";
var PaginationContent = React28.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx34(
    "ul",
    __spreadValues({
      ref,
      className: cn("flex flex-row items-center gap-1", className)
    }, props)
  );
});
PaginationContent.displayName = "PaginationContent";
var PaginationItem = React28.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx34("li", __spreadValues({ ref, className: cn("cursor-pointer", className) }, props));
});
PaginationItem.displayName = "PaginationItem";
var PaginationLink = (_a) => {
  var _b = _a, {
    className,
    isActive,
    size = "icon",
    LinkComponent = void 0
  } = _b, props = __objRest(_b, [
    "className",
    "isActive",
    "size",
    "LinkComponent"
  ]);
  if (LinkComponent) {
    return /* @__PURE__ */ jsx34(
      LinkComponent,
      __spreadProps(__spreadValues({
        className: cn(
          buttonVariants({
            variant: isActive ? "outline" : "ghost",
            size
          }),
          className
        )
      }, props), {
        children: props.children
      })
    );
  }
  return /* @__PURE__ */ jsx34(
    "a",
    __spreadProps(__spreadValues({
      "aria-current": isActive ? "page" : void 0,
      className: cn(
        buttonVariants({
          variant: isActive ? "outline" : "ghost",
          size
        }),
        className
      )
    }, props), {
      children: props.children
    })
  );
};
PaginationLink.displayName = "PaginationLink";
var PaginationPrevious = (_a) => {
  var _b = _a, {
    className
  } = _b, props = __objRest(_b, [
    "className"
  ]);
  return /* @__PURE__ */ jsxs13(
    PaginationLink,
    __spreadProps(__spreadValues({
      "aria-label": "Go to previous page",
      size: "default",
      className: cn("gap-1 pl-2.5", className)
    }, props), {
      children: [
        /* @__PURE__ */ jsx34(ChevronLeft2, { className: "h-4 w-4" }),
        /* @__PURE__ */ jsx34("span", { children: "Previous" })
      ]
    })
  );
};
PaginationPrevious.displayName = "PaginationPrevious";
var PaginationNext = (_a) => {
  var _b = _a, {
    className
  } = _b, props = __objRest(_b, [
    "className"
  ]);
  return /* @__PURE__ */ jsxs13(
    PaginationLink,
    __spreadProps(__spreadValues({
      "aria-label": "Go to next page",
      size: "default",
      className: cn("gap-1 pr-2.5", className)
    }, props), {
      children: [
        /* @__PURE__ */ jsx34("span", { children: "Next" }),
        /* @__PURE__ */ jsx34(ChevronRight4, { className: "h-4 w-4" })
      ]
    })
  );
};
PaginationNext.displayName = "PaginationNext";
var PaginationEllipsis = (_a) => {
  var _b = _a, {
    className
  } = _b, props = __objRest(_b, [
    "className"
  ]);
  return /* @__PURE__ */ jsxs13(
    "span",
    __spreadProps(__spreadValues({
      "aria-hidden": true,
      className: cn("flex h-9 w-9 items-center justify-center", className)
    }, props), {
      children: [
        /* @__PURE__ */ jsx34(MoreHorizontal2, { className: "h-4 w-4" }),
        /* @__PURE__ */ jsx34("span", { className: "sr-only", children: "More pages" })
      ]
    })
  );
};
PaginationEllipsis.displayName = "PaginationEllipsis";

// src/components/uturn-ui/index.ts
var uturn_ui_exports = {};
__export(uturn_ui_exports, {
  AgGridReact: () => AgGridReact,
  AutoComplete: () => AutoComplete,
  AverageLine: () => AverageLine,
  Callout: () => Callout,
  CalloutIcon: () => CalloutIcon,
  CalloutTitle: () => CalloutTitle,
  Chart: () => Chart,
  ChartCustomTooltip: () => ChartCustomTooltip,
  CopyToClipboard: () => CopyToClipboard,
  DatePicker: () => DatePicker,
  EmptyState: () => EmptyState,
  FormFieldReadOnly: () => FormFieldReadOnly,
  Icon: () => Icon,
  InputAddon: () => InputAddon,
  LicenseManager: () => LicenseManager,
  Logo: () => Logo,
  MoneyCell: () => money_cell_default,
  MultiSelect: () => MultiSelect,
  MultiSelectBadge: () => MultiSelectBadge2,
  PaginationCompact: () => PaginationCompact,
  PopoverSelect: () => PopoverSelect,
  Ratings: () => Ratings,
  Stars: () => Stars,
  formatDate: () => formatDate,
  formatDatetime: () => formatDatetime,
  inputDatetimeFormatOptions: () => inputDatetimeFormatOptions
});

// src/components/uturn-ui/form-field-read-only.tsx
import { twJoin } from "tailwind-merge";
import { jsx as jsx35 } from "react/jsx-runtime";
function FormFieldReadOnly(_a) {
  var _b = _a, {
    value,
    className
  } = _b, props = __objRest(_b, [
    "value",
    "className"
  ]);
  return /* @__PURE__ */ jsx35(
    "p",
    __spreadProps(__spreadValues({
      className: twJoin("text-sm text-muted-foreground", className)
    }, props), {
      children: value === "" || !value ? "-" : value
    })
  );
}

// src/components/uturn-ui/auto-complete.tsx
import { Command as CommandPrimitive2 } from "cmdk";
import {
  useCallback,
  useEffect as useEffect2,
  useRef,
  useState as useState3
} from "react";
import { useDebouncedCallback as useDebouncedCallback2 } from "use-debounce";
import { jsx as jsx36, jsxs as jsxs14 } from "react/jsx-runtime";
function AutoComplete({
  options,
  placeholder,
  emptyMessage,
  value,
  onValueChange,
  onInputChange,
  setSelected,
  disabled,
  forceUniqueLabelsEnabled,
  debouncerDelay,
  refCallback
}) {
  const inputRef = useRef(null);
  const [isOpen, setOpen] = useState3(false);
  const [inputValue, setInputValue] = useState3(value != null ? value : "");
  const handleKeyDown = useCallback(
    (event) => {
      const input = inputRef.current;
      if (!input) {
        return;
      }
      if (!isOpen) {
        setOpen(true);
      }
      if (event.key === "Enter" && input.value !== "") {
        const indexOfOption = options.findIndex(
          (option) => option.label === input.value
        );
        if (indexOfOption !== -1) {
          setSelected == null ? void 0 : setSelected(indexOfOption);
        }
      }
      if (event.key === "Escape") {
        input.blur();
      }
    },
    [isOpen, options, onValueChange, onInputChange]
  );
  const handleBlur = useCallback(() => {
    setOpen(false);
  }, []);
  const handleSelectOption = useCallback(
    (selectedOption, index) => {
      setInputValue(selectedOption.label);
      setSelected == null ? void 0 : setSelected(index);
      setTimeout(() => {
        var _a;
        (_a = inputRef == null ? void 0 : inputRef.current) == null ? void 0 : _a.blur();
      }, 0);
    },
    [onValueChange, onInputChange]
  );
  useEffect2(() => {
    if (value !== void 0) {
      setInputValue(value);
    }
  }, [value]);
  useEffect2(() => {
    onValueChange == null ? void 0 : onValueChange(inputValue);
  }, [inputValue]);
  const debouncer = useDebouncedCallback2((targetValue) => {
    onInputChange == null ? void 0 : onInputChange(targetValue);
  }, debouncerDelay || 0);
  const handleChange = (e) => {
    const targetValue = e.target.value || "";
    setInputValue(targetValue);
    if (isOpen) {
      debouncer(targetValue);
    }
  };
  return /* @__PURE__ */ jsxs14(CommandPrimitive2, { onKeyDown: handleKeyDown, children: [
    /* @__PURE__ */ jsx36("div", { children: /* @__PURE__ */ jsx36(
      Input,
      {
        ref: (el) => {
          if (refCallback && el) {
            refCallback(el);
            inputRef.current = el;
          }
        },
        value: inputValue,
        onChange: handleChange,
        onBlur: handleBlur,
        onFocus: () => {
          setOpen(true);
        },
        placeholder,
        disabled
      }
    ) }),
    /* @__PURE__ */ jsx36("div", { className: "mt-1 relative", children: isOpen && inputValue.length > 2 ? /* @__PURE__ */ jsx36("div", { className: "absolute top-0 z-10 w-full rounded-x bg-background outline-none animate-in fade-in-0 zoom-in-95", children: /* @__PURE__ */ jsxs14(CommandList, { className: "ring-1 ring-accent rounded-lg", children: [
      options.length > 0 ? /* @__PURE__ */ jsx36(CommandGroup, { children: options.map((option, index) => {
        return /* @__PURE__ */ jsx36(
          CommandItem,
          {
            value: (forceUniqueLabelsEnabled != null ? forceUniqueLabelsEnabled : false) === true ? `${option.label}-${index}` : option.label,
            onMouseDown: (event) => {
              event.preventDefault();
              event.stopPropagation();
            },
            onSelect: () => handleSelectOption(option, index),
            className: cn("flex items-center gap-2 w-full"),
            children: option.label
          },
          `${option.value}-${index}`
        );
      }) }) : null,
      options.length === 0 ? /* @__PURE__ */ jsx36(CommandPrimitive2.Empty, { className: "select-none rounded-sm px-2 py-3 text-sm text-center", children: emptyMessage }) : null
    ] }) }) : null })
  ] });
}

// src/components/uturn-ui/callout.tsx
import { cva as cva7 } from "class-variance-authority";
import * as React29 from "react";
import { jsx as jsx37 } from "react/jsx-runtime";
var calloutVariants = cva7(
  "relative w-full rounded-lg border p-4 flex items-center gap-4",
  {
    variants: {
      variant: {
        default: "text-secondary-foreground bg-secondary",
        destructive: "border-destructive/50 text-destructive bg-red-50 dark:bg-red-500 dark:text-destructive-foreground dark:border-destructive"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
);
var Callout = React29.forwardRef((_a, ref) => {
  var _b = _a, { className, variant } = _b, props = __objRest(_b, ["className", "variant"]);
  return /* @__PURE__ */ jsx37(
    "div",
    __spreadValues({
      ref,
      className: cn(calloutVariants({ variant }), className)
    }, props)
  );
});
Callout.displayName = "Callout";
var CalloutIcon = React29.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx37("span", __spreadProps(__spreadValues({}, props), { className: cn("", className), ref, children: props.children }));
});
CalloutIcon.displayName = "CalloutIcon";
var CalloutTitle = React29.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  return /* @__PURE__ */ jsx37("p", __spreadProps(__spreadValues({ ref, className: cn("tracking-tight text-sm", className) }, props), { children: props.children }));
});
CalloutTitle.displayName = "CalloutTitle";

// src/components/uturn-ui/stars/stars.tsx
import { faStar } from "@fortawesome/pro-solid-svg-icons";
import { cva as cva8 } from "class-variance-authority";
import { jsx as jsx38 } from "react/jsx-runtime";
var starVariants = cva8("flex-shrink-0 text-muted-foreground/30", {
  variants: {
    size: {
      default: "h-5 w-5",
      xs: "h-3 w-3",
      sm: "h-4 w-4",
      lg: "h-7 w-7"
    }
  },
  defaultVariants: {
    size: "default"
  }
});
function Stars({ rating, size }) {
  return /* @__PURE__ */ jsx38("div", { className: "flex items-center", children: [0, 1, 2, 3, 4].map((index) => /* @__PURE__ */ jsx38(
    Icon,
    {
      icon: faStar,
      className: cn(
        starVariants({
          size,
          className: rating > index && "text-yellow-300"
        })
      ),
      "aria-hidden": "true"
    },
    index
  )) });
}

// src/components/uturn-ui/stars/ratings.tsx
import { faStar as faStar2 } from "@fortawesome/pro-solid-svg-icons";
import { useState as useState4 } from "react";
import { twMerge as twMerge2 } from "tailwind-merge";
import { jsx as jsx39, jsxs as jsxs15 } from "react/jsx-runtime";
function Ratings(_a) {
  var _b = _a, { value, disabled = false } = _b, props = __objRest(_b, ["value", "disabled"]);
  const [rating, setRating] = useState4(Number(value));
  const [hover, setHover] = useState4(void 0);
  if (disabled) {
    return /* @__PURE__ */ jsx39(Stars, { rating: value });
  }
  return /* @__PURE__ */ jsx39("div", __spreadProps(__spreadValues({ className: "flex items-center" }, props), { children: [0, 1, 2, 3, 4].map((index) => {
    return (
      // eslint-disable-next-line jsx-a11y/label-has-associated-control
      /* @__PURE__ */ jsxs15("label", { children: [
        /* @__PURE__ */ jsx39(
          "input",
          {
            type: "radio",
            name: "rating",
            value: index + 1,
            className: "hidden",
            onClick: () => setRating(index + 1)
          }
        ),
        /* @__PURE__ */ jsx39(
          Icon,
          {
            icon: faStar2,
            "aria-hidden": "true",
            onMouseEnter: () => setHover(index + 1),
            onMouseLeave: () => setHover(void 0),
            className: twMerge2(
              "h-5 w-5 flex-shrink-0 text-muted-foreground/30",
              index < (hover != null ? hover : rating) && "text-primary"
            )
          }
        )
      ] }, `label-${index}`)
    );
  }) }));
}

// src/components/uturn-ui/select/multi-select.tsx
import { faXmark } from "@fortawesome/pro-regular-svg-icons";
import { Check as Check4, ChevronDown as ChevronDown4 } from "lucide-react";
import { useState as useState5 } from "react";
import { Fragment, jsx as jsx40, jsxs as jsxs16 } from "react/jsx-runtime";
var defaults = {
  placeholder: "Select an option",
  filter: {
    placeholder: "Search ...",
    empty: "No item found."
  },
  actions: { selectAll: "Select all" }
};
function MultiSelectBadge({
  label,
  variant,
  onUnselect
}) {
  return /* @__PURE__ */ jsxs16(
    Badge,
    {
      variant,
      onClick: () => {
        if (onUnselect)
          onUnselect();
      },
      children: [
        label,
        /* @__PURE__ */ jsx40(
          "div",
          {
            role: "button",
            tabIndex: 0,
            "aria-pressed": "false",
            className: "ml-1 ring-offset-background rounded-full outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
            onKeyDown: (e) => {
              if (e.key === "Enter") {
                if (onUnselect)
                  onUnselect();
              }
            },
            onMouseDown: (e) => {
              e.preventDefault();
              e.stopPropagation();
            },
            onClick: () => {
              if (onUnselect)
                onUnselect();
            },
            children: onUnselect && /* @__PURE__ */ jsx40(Icon, { icon: faXmark })
          }
        )
      ]
    }
  );
}
function MultiSelect({
  options,
  exclusions,
  selected,
  onChange,
  className,
  placeholder,
  selectAllEnabled = false,
  variant = "secondary",
  align = "center",
  filter,
  disabled = false
}) {
  const [open, setOpen] = useState5(false);
  const unselected = (exclusions == null ? void 0 : exclusions.length) ? exclusions == null ? void 0 : exclusions.filter((option) => selected.includes(option.value)) : [];
  const [selectAll, setSelectAll] = useState5(
    selected.length === unselected.length + options.length
  );
  const handleFilter = (value, search) => {
    if (filter == null ? void 0 : filter.onFilter) {
      return filter.onFilter(value, search);
    }
    return value.includes(search.toLowerCase()) ? 1 : 0;
  };
  const handleUnselect = (selectedValue) => {
    onChange(selected.filter((value) => value !== selectedValue));
    setSelectAll(false);
  };
  const toggleSelect = (optionValue) => {
    if (selected.includes(optionValue)) {
      handleUnselect(optionValue);
    } else {
      const newSelected = [...selected, optionValue];
      onChange(newSelected);
      if (newSelected.length === unselected.length + options.length) {
        setSelectAll(true);
      }
    }
    setOpen(true);
  };
  const toggleSelectAll = () => {
    if (selectAll) {
      onChange(unselected.map((option) => option.value));
      setSelectAll(false);
    } else {
      onChange([
        ...unselected.map((option) => option.value),
        ...options.map((option) => option.value)
      ]);
      setSelectAll(true);
    }
    setOpen(true);
  };
  return /* @__PURE__ */ jsxs16(Popover, { open, onOpenChange: setOpen, children: [
    /* @__PURE__ */ jsx40(PopoverTrigger, { asChild: true, children: /* @__PURE__ */ jsxs16(
      Button,
      {
        variant: "outline",
        role: "combobox",
        "aria-expanded": open,
        className: cn(
          "w-full justify-between transition-all [&[data-state=open]>svg]:rotate-180",
          selected.length > 1 ? "h-full" : "h-10"
        ),
        disabled,
        onClick: () => setOpen(!open),
        children: [
          /* @__PURE__ */ jsxs16("div", { className: "flex gap-x-2 gap-y-2 flex-wrap", children: [
            !selected.length && !unselected.length && placeholder && /* @__PURE__ */ jsx40("span", { className: "text-muted-foreground", children: placeholder }),
            unselected.map((option) => {
              return /* @__PURE__ */ jsx40(
                MultiSelectBadge,
                {
                  variant,
                  label: option.label
                },
                option.value
              );
            }),
            selected.length === unselected.length + options.length && /* @__PURE__ */ jsx40(
              MultiSelectBadge,
              {
                variant,
                label: `All selected (${selected.length - unselected.length})`,
                onUnselect: disabled ? void 0 : () => toggleSelectAll()
              }
            ),
            selected.length < unselected.length + options.length && options.filter((option) => selected.includes(option.value)).map((option) => {
              return /* @__PURE__ */ jsx40(
                MultiSelectBadge,
                {
                  variant,
                  label: option.label,
                  onUnselect: disabled ? void 0 : () => handleUnselect(option.value)
                },
                option.value
              );
            })
          ] }),
          !disabled && /* @__PURE__ */ jsx40(ChevronDown4, { className: "h-4 w-4 shrink-0 transition-transform duration-200" })
        ]
      }
    ) }),
    /* @__PURE__ */ jsx40(
      PopoverContent,
      {
        align,
        className: cn(
          "w-[var(--radix-popover-trigger-width)] max-h-[300px] p-0",
          className
        ),
        children: /* @__PURE__ */ jsxs16(Command, { filter: handleFilter, children: [
          /* @__PURE__ */ jsx40(
            CommandInput,
            {
              placeholder: (filter == null ? void 0 : filter.placeholder) || defaults.filter.placeholder
            }
          ),
          /* @__PURE__ */ jsx40(CommandEmpty, { children: (filter == null ? void 0 : filter.empty) || defaults.filter.empty }),
          /* @__PURE__ */ jsxs16(CommandGroup, { className: "max-h-64 overflow-auto", children: [
            selectAllEnabled && /* @__PURE__ */ jsxs16(Fragment, { children: [
              /* @__PURE__ */ jsxs16(CommandItem, { onSelect: toggleSelectAll, children: [
                /* @__PURE__ */ jsx40(
                  Check4,
                  {
                    className: cn(
                      "mr-2 h-4 w-4",
                      selectAll ? "opacity-100" : "opacity-0"
                    )
                  }
                ),
                defaults.actions.selectAll
              ] }),
              /* @__PURE__ */ jsx40(Separator3, { className: "my-1" })
            ] }),
            options.map((option) => {
              return /* @__PURE__ */ jsxs16(
                CommandItem,
                {
                  onSelect: () => toggleSelect(option.value),
                  children: [
                    /* @__PURE__ */ jsx40(
                      Check4,
                      {
                        className: cn(
                          "mr-2 h-4 w-4",
                          selected.includes(option.value) ? "opacity-100" : "opacity-0"
                        )
                      }
                    ),
                    option.label
                  ]
                },
                option.value
              );
            })
          ] })
        ] })
      }
    )
  ] });
}

// src/components/uturn-ui/select/multi-select-badge.tsx
import { jsxs as jsxs17 } from "react/jsx-runtime";
function MultiSelectBadge2({
  label,
  removeValue,
  removeIcon,
  disableRemoveValue
}) {
  return /* @__PURE__ */ jsxs17(
    Badge,
    {
      className: "mr-2 flex items-center gap-1",
      onClick: (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (disableRemoveValue)
          return;
        removeValue();
      },
      children: [
        label,
        !disableRemoveValue && removeIcon
      ]
    }
  );
}

// src/components/uturn-ui/select/select.tsx
import { faCheck } from "@fortawesome/pro-regular-svg-icons";
import { ChevronDown as ChevronDown5 } from "lucide-react";
import { forwardRef as forwardRef30, useState as useState6 } from "react";
import { twJoin as twJoin2 } from "tailwind-merge";
import { jsx as jsx41, jsxs as jsxs18 } from "react/jsx-runtime";
var defaults2 = {
  placeholder: "Select an option",
  filter: {
    placeholder: "Type to search",
    empty: "No results found."
  }
};
var PopoverSelect = forwardRef30(function PopoverSelect2({
  options,
  selected,
  onChange,
  onSelect,
  className,
  placeholder,
  filter,
  nullable = false,
  align = "start",
  position = "default"
}, ref) {
  const [open, setOpen] = useState6(false);
  const handleOnSelect = (option) => {
    if (option) {
      onChange(option.value);
      if (onSelect) {
        onSelect(option.raw);
      }
    } else {
      onChange("");
    }
    setOpen(false);
  };
  const handleOnFilter = (value, search) => {
    if (filter == null ? void 0 : filter.onFilter) {
      return filter.onFilter(value, search);
    }
    return value.includes(search.toLowerCase()) ? 1 : 0;
  };
  const selectedOption = selected ? options.find(
    (option) => option.value === selected || option.source && option.source === selected
  ) : void 0;
  return /* @__PURE__ */ jsxs18(Popover, { open, onOpenChange: setOpen, children: [
    /* @__PURE__ */ jsx41(PopoverTrigger, { asChild: true, children: /* @__PURE__ */ jsxs18(
      Button,
      {
        ref,
        variant: "outline",
        role: "combobox",
        className: twJoin2(
          "w-full justify-between transition-all [&[data-state=open]>svg]:rotate-180",
          !selected && "text-muted-foreground"
        ),
        children: [
          /* @__PURE__ */ jsx41("p", { className: "truncate", children: selectedOption ? selectedOption.label : placeholder || defaults2.placeholder }),
          /* @__PURE__ */ jsx41(ChevronDown5, { className: "h-4 w-4 shrink-0 transition-transform duration-200" })
        ]
      }
    ) }),
    /* @__PURE__ */ jsx41(
      PopoverContent,
      {
        align,
        className: twJoin2(
          "w-[var(--radix-popover-trigger-width)] p-0",
          className
        ),
        children: /* @__PURE__ */ jsxs18(Command, { filter: handleOnFilter, children: [
          /* @__PURE__ */ jsx41(
            CommandInput,
            {
              placeholder: (filter == null ? void 0 : filter.placeholder) || defaults2.filter.placeholder
            }
          ),
          /* @__PURE__ */ jsx41(CommandEmpty, { children: (filter == null ? void 0 : filter.empty) || defaults2.filter.empty }),
          /* @__PURE__ */ jsxs18(CommandGroup, { className: "h-[300px] overflow-y-scroll", children: [
            nullable && selected && position !== "top" && /* @__PURE__ */ jsxs18(
              CommandItem,
              {
                value: "None",
                className: "font-bold py-2",
                onSelect: () => handleOnSelect(),
                children: [
                  /* @__PURE__ */ jsx41(
                    Icon,
                    {
                      icon: faCheck,
                      className: twJoin2("mr-2 h-4 w-4", "opacity-0")
                    }
                  ),
                  "None"
                ]
              }
            ),
            position === "top" && selected && selectedOption && /* @__PURE__ */ jsxs18(
              CommandItem,
              {
                value: selectedOption.label,
                onSelect: () => nullable ? handleOnSelect() : void 0,
                children: [
                  /* @__PURE__ */ jsx41(
                    Icon,
                    {
                      icon: faCheck,
                      className: twJoin2("mr-2 h-4 w-4", "opacity-100")
                    }
                  ),
                  selectedOption.label
                ]
              },
              selectedOption.value
            ),
            options == null ? void 0 : options.map((option) => {
              if (selectedOption && option.value === selectedOption.value && position !== "default") {
                return null;
              }
              return /* @__PURE__ */ jsxs18(
                CommandItem,
                {
                  value: option.label,
                  onSelect: () => handleOnSelect(option),
                  children: [
                    /* @__PURE__ */ jsx41(
                      Icon,
                      {
                        icon: faCheck,
                        className: twJoin2(
                          "mr-2 h-4 w-4",
                          selectedOption && option.value === selectedOption.value ? "opacity-100" : "opacity-0"
                        )
                      }
                    ),
                    option.label
                  ]
                },
                option.value
              );
            }),
            position === "bottom" && selected && selectedOption && /* @__PURE__ */ jsxs18(
              CommandItem,
              {
                value: selectedOption.label,
                children: [
                  /* @__PURE__ */ jsx41(
                    Icon,
                    {
                      icon: faCheck,
                      className: twJoin2("mr-2 h-4 w-4", "opacity-100")
                    }
                  ),
                  selectedOption.label
                ]
              },
              selectedOption.value
            )
          ] })
        ] })
      }
    )
  ] });
});

// src/components/uturn-ui/pagination/pagination.tsx
import { useState as useState7 } from "react";
import { jsx as jsx42, jsxs as jsxs19 } from "react/jsx-runtime";
function PaginationCompact({
  page,
  setPage,
  totalPages,
  pageLimit = 5
}) {
  const [startPage, setStartPage] = useState7(0);
  if (!totalPages)
    return null;
  return /* @__PURE__ */ jsx42(Pagination, { children: /* @__PURE__ */ jsxs19(PaginationContent, { children: [
    /* @__PURE__ */ jsx42(
      PaginationItem,
      {
        "aria-disabled": page === 0,
        onClick: () => {
          if (page !== 0) {
            setPage(page - 1);
            if (page - 1 < startPage) {
              setStartPage(Math.max(0, startPage - pageLimit));
            }
          }
        },
        children: /* @__PURE__ */ jsx42(PaginationPrevious, {})
      }
    ),
    startPage !== 0 && /* @__PURE__ */ jsx42(
      PaginationItem,
      {
        onClick: () => {
          setPage(startPage);
          setStartPage(Math.max(0, startPage - pageLimit));
        },
        children: /* @__PURE__ */ jsx42(PaginationEllipsis, {})
      }
    ),
    Array(totalPages).fill(0).slice(startPage, startPage + pageLimit).map((_, i) => /* @__PURE__ */ jsx42(
      PaginationItem,
      {
        "aria-current": page === i + startPage,
        onClick: () => setPage(i + startPage),
        children: /* @__PURE__ */ jsx42(PaginationLink, { isActive: page === i + startPage, children: i + startPage + 1 })
      },
      i + startPage
    )),
    startPage + pageLimit < totalPages && /* @__PURE__ */ jsx42(
      PaginationItem,
      {
        onClick: () => {
          setPage(Math.min(totalPages - pageLimit, startPage + pageLimit));
          setStartPage(
            Math.min(totalPages - pageLimit, startPage + pageLimit)
          );
        },
        children: /* @__PURE__ */ jsx42(PaginationEllipsis, {})
      }
    ),
    /* @__PURE__ */ jsx42(
      PaginationItem,
      {
        "aria-disabled": page === totalPages - 1,
        onClick: () => {
          if (page !== totalPages - 1) {
            setPage(page + 1);
            if (page + 1 >= startPage + pageLimit) {
              setStartPage(
                Math.min(totalPages - pageLimit, startPage + pageLimit)
              );
            }
          }
        },
        children: /* @__PURE__ */ jsx42(PaginationNext, {})
      }
    )
  ] }) });
}

// src/components/uturn-ui/ag-grid/index.tsx
var ag_grid_exports = {};
__export(ag_grid_exports, {
  AgGridReact: () => AgGridReact,
  LicenseManager: () => LicenseManager,
  MoneyCell: () => money_cell_default
});
__reExport(ag_grid_exports, ag_grid_community_star);
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { LicenseManager } from "ag-grid-enterprise";
import * as ag_grid_community_star from "ag-grid-community";
import {
  AgGridReact
} from "ag-grid-react";

// src/components/uturn-ui/ag-grid/money-cell.tsx
import { CurrencyUtils } from "@uturn/utilities/browser";
import { Fragment as Fragment2, jsx as jsx43 } from "react/jsx-runtime";
var MoneyCell = (props) => {
  var _a, _b;
  if (typeof props.value !== "object") {
    return /* @__PURE__ */ jsx43(Fragment2, { children: props.value });
  }
  if (!Object.keys(props.value).includes("amount") || !Object.keys(props.value).includes("currency")) {
    return /* @__PURE__ */ jsx43(Fragment2, { children: JSON.stringify(props.value) });
  }
  return /* @__PURE__ */ jsx43(Fragment2, { children: CurrencyUtils.formatPriceString(
    (_a = props.value) == null ? void 0 : _a.amount,
    (_b = props.value) == null ? void 0 : _b.currency,
    window.navigator.language
  ) });
};
var money_cell_default = MoneyCell;

// src/components/uturn-ui/index.ts
__reExport(uturn_ui_exports, ag_grid_exports);

// src/components/uturn-ui/copy-to-clipboard/index.tsx
import { faCopy } from "@fortawesome/pro-regular-svg-icons";
import { useState as useState8 } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { jsx as jsx44, jsxs as jsxs20 } from "react/jsx-runtime";
var CopyToClipboard = ({
  value,
  successMessage,
  className
}) => {
  const [openTooltip, setOpenTooltip] = useState8(false);
  return /* @__PURE__ */ jsxs20(
    Button,
    {
      variant: "link",
      size: "icon",
      onClick: (e) => {
        e.preventDefault();
        navigator.clipboard.writeText(value);
        setOpenTooltip(true);
        setTimeout(() => setOpenTooltip(false), 1e3);
      },
      className: cn("relative size-6", className),
      children: [
        /* @__PURE__ */ jsx44(Icon, { className: "text-muted-foreground", icon: faCopy }),
        /* @__PURE__ */ jsx44(AnimatePresence, { children: openTooltip && /* @__PURE__ */ jsx44(
          motion.div,
          {
            initial: { opacity: 0, y: 10 },
            animate: { opacity: 1, y: 0 },
            exit: { opacity: 0, y: 10 },
            className: "absolute -top-10 z-50 overflow-hidden rounded-md border bg-popover px-3 py-1.5 text-sm text-popover-foreground shadow-md",
            children: successMessage
          }
        ) })
      ]
    }
  );
};

// src/components/uturn-ui/logo.tsx
import { useId as useId2 } from "react";
import { jsx as jsx45, jsxs as jsxs21 } from "react/jsx-runtime";
function Logo(_a) {
  var _b = _a, { className, variant = "default" } = _b, props = __objRest(_b, ["className", "variant"]);
  const fillId = useId2();
  if (variant === "christmas") {
    return /* @__PURE__ */ jsxs21(
      "svg",
      {
        width: "186",
        height: "61",
        viewBox: "0 0 186 61",
        className: `${className} fill-[#131628] dark:fill-white`,
        children: [
          /* @__PURE__ */ jsx45(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M21.7602 47.4871C21.9922 46.374 22.1095 45.2237 22.1095 44.0677V27.2207H30.5173V44.0677C30.5173 46.3337 30.2175 48.4791 29.6261 50.444C29.0316 52.419 28.1008 54.1732 26.8616 55.6567C25.6185 57.1446 24.0161 58.3302 22.0982 59.1808C20.1866 60.0295 17.8855 60.4598 15.2583 60.4598C12.5358 60.4598 10.177 60.0055 8.24724 59.1101C6.31369 58.2128 4.71943 56.9956 3.509 55.492C2.3017 53.9934 1.40423 52.2322 0.842284 50.2578C0.282851 48.2973 0 46.2144 0 44.0677V27.2207H8.4078V44.0677C8.4078 45.2875 8.53323 46.4592 8.77971 47.5502C9.02242 48.6311 9.42318 49.6079 9.9707 50.4535C10.5094 51.2876 11.215 51.9584 12.0686 52.4468C12.9171 52.9333 13.9908 53.1794 15.2583 53.1794C16.5252 53.1794 17.6058 52.9257 18.4713 52.4247C19.3406 51.9212 20.0555 51.2428 20.5943 50.4087C21.1399 49.565 21.5319 48.5825 21.7602 47.4871ZM44.7238 34.4097H34.4276V27.2207H63.3801V34.4097H53.1315V60.1866H44.7238V34.4097ZM122.033 38.4664C122.033 39.6918 121.721 40.7058 121.106 41.48C120.499 42.2429 119.803 42.6139 118.978 42.6139H112.175V34.4097H118.74C119.545 34.4097 120.278 34.7656 120.983 35.4975C121.68 36.2232 122.033 37.222 122.033 38.4664ZM127.284 46.4138C127.982 45.743 128.584 44.9764 129.071 44.1353C129.556 43.2954 129.934 42.3886 130.193 41.4415C130.452 40.4919 130.584 39.4911 130.584 38.4664C130.584 37.0971 130.296 35.7221 129.728 34.38C129.162 33.0467 128.367 31.8352 127.365 30.7789C126.361 29.7232 125.156 28.8575 123.785 28.2069C122.405 27.5526 120.884 27.2207 119.262 27.2207H103.766V60.1866H112.175V49.7574H116.767L123.553 60.1866H133.076L125.213 47.961C125.971 47.5256 126.667 47.0063 127.284 46.4138ZM158.417 45.6547V27.2207H166.825V60.1866H160.103L145.048 42.2435V60.1866H136.639V27.2207H143.172L143.267 27.3343L158.417 45.6547Z"
            }
          ),
          /* @__PURE__ */ jsx45(
            "path",
            {
              d: "M85.9097 30.833H89.4011V43.8268C89.4011 44.9863 89.2994 46.1459 89.0621 47.2713C88.8249 48.3627 88.452 49.3517 87.8757 50.2043C87.3334 51.0228 86.6215 51.7049 85.7741 52.2165C84.8928 52.6939 83.8081 52.9667 82.5539 52.9667C81.2658 52.9667 80.215 52.728 79.3675 52.2165C78.5201 51.739 77.8083 51.0569 77.2659 50.2384C76.7236 49.3858 76.3168 48.3968 76.0456 47.3054C75.8083 46.2141 75.6727 45.0545 75.6727 43.8268V27.0133H67.3001V43.8268C67.3001 45.9754 67.5713 48.0557 68.1476 49.9997C68.6899 51.9777 69.6051 53.7511 70.7915 55.2176C72.0118 56.7523 73.605 57.946 75.5371 58.8327C77.4693 59.7535 79.8421 60.1969 82.5539 60.1969C85.164 60.1969 87.469 59.7535 89.4011 58.935C91.2994 58.0824 92.8925 56.8887 94.1467 55.3882C95.4009 53.9217 96.3161 52.1823 96.9263 50.2043C97.5025 48.2262 97.8076 46.0777 97.8076 43.8268V30.833H101.197L93.401 22L85.9097 30.833Z",
              fill: `url(#${fillId})`
            }
          ),
          /* @__PURE__ */ jsx45(
            "path",
            {
              d: "M162.711 26.5129C154.619 23.2682 142.338 18.8695 138.545 18.176C141.558 14.1008 145.355 10.6687 149.712 8.08089C156.541 4.03067 168.005 0.530772 172.049 7.35094C173.356 9.55191 174.724 17.5298 176.659 22.9953C176.441 23.093 176.224 23.2093 176.014 23.334C175.486 23.6438 174.993 24.0086 174.541 24.4221C172.326 22.3095 169.644 18.9407 167.809 18.0498C163.896 11.4536 170.146 21.1613 163.317 26.7547C163.118 26.6764 162.916 26.593 162.711 26.5129Z",
              fill: "#FF2946"
            }
          ),
          /* @__PURE__ */ jsx45(
            "path",
            {
              d: "M178.719 22.4017C179.983 22.5353 180.499 22.9314 181.947 23.6894C182.693 24.0801 183.587 25.3517 183.587 25.3517C184.157 26.3133 183.264 26.9675 184.284 28.6867C184.354 30.3928 183.525 31.2257 182.366 31.9135C181.316 32.5368 180.167 33.0781 179.034 33.4074C179.002 33.3611 178.973 33.317 178.945 33.2714C178.762 32.9623 180.458 24.1527 179.901 23.2135C179.649 22.7882 179.114 22.6568 178.6 22.4795C178.635 22.461 178.662 22.4382 178.698 22.4142L178.719 22.4017Z",
              fill: "#D9D9D9"
            }
          ),
          /* @__PURE__ */ jsx45(
            "path",
            {
              d: "M176.659 22.9967C176.688 22.9801 176.718 22.965 176.748 22.9515C177.373 22.6721 177.966 22.8555 178.57 22.4973L178.6 22.4795C179.114 22.6568 179.649 22.7895 179.902 23.2133C180.458 24.1527 178.761 32.9625 178.946 33.2713C178.973 33.317 179.002 33.3611 179.034 33.4074C176.787 34.0606 174.6 33.8698 173.37 31.7959C171.968 29.4315 172.242 26.5523 174.541 24.4221C174.993 24.0085 175.486 23.6438 176.014 23.334C176.224 23.2093 176.441 23.093 176.659 22.9967Z",
              fill: "#EBEBEB"
            }
          ),
          /* @__PURE__ */ jsx45(
            "path",
            {
              d: "M163.317 26.7547C170.146 21.1613 163.896 11.4536 167.81 18.0496C168.078 21.3466 168.654 25.2137 167.825 28.6614C166.651 28.1291 165.1 27.4747 163.317 26.7547Z",
              fill: "#E82E52"
            }
          ),
          /* @__PURE__ */ jsx45(
            "path",
            {
              d: "M167.825 28.6614C166.651 28.1291 165.1 27.4747 163.317 26.7547C163.118 26.6764 162.916 26.593 162.711 26.5128L162.934 27.0564C164.216 30.0844 166.366 33.868 161.154 37.001C163.972 38.2359 166.187 38.8982 167.286 38.2461C168.089 37.7676 171.19 31.6913 170.143 29.9291C170.023 29.7276 169.174 29.2755 167.825 28.6614Z",
              fill: "#D9D9D9"
            }
          ),
          /* @__PURE__ */ jsx45(
            "path",
            {
              d: "M138.546 18.1758C142.338 18.8708 154.619 23.2682 162.711 26.5128L162.934 27.0551C164.216 30.0844 166.366 33.868 161.154 37.001C155.291 34.4301 146.829 29.3742 140.461 28.5006C138.548 28.2375 135.625 28.3273 134.733 26.8233C133.692 25.0682 135.791 21.2026 136.39 18.8575C136.724 18.6581 137.089 18.3471 137.448 18.1334C137.589 18.051 137.97 18.0733 138.546 18.1758Z",
              fill: "#EBEBEB"
            }
          ),
          /* @__PURE__ */ jsx45("defs", { children: /* @__PURE__ */ jsxs21(
            "linearGradient",
            {
              id: fillId,
              x1: "67.3001",
              y1: "41.0983",
              x2: "101.197",
              y2: "41.0983",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx45("stop", { stopColor: "#00BFEC" }),
                /* @__PURE__ */ jsx45("stop", { offset: "1", stopColor: "#00C587" })
              ]
            }
          ) })
        ]
      }
    );
  }
  return /* @__PURE__ */ jsxs21(
    "svg",
    __spreadProps(__spreadValues({}, props), {
      className: `${className} fill-[#131628] dark:fill-white`,
      viewBox: "0 0 167 39",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx45(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M21.7602 25.4871C21.9922 24.374 22.1095 23.2237 22.1095 22.0677V5.2207H30.5173V22.0677C30.5173 24.3337 30.2175 26.4791 29.6261 28.444C29.0316 30.419 28.1008 32.1732 26.8616 33.6567C25.6185 35.1446 24.0161 36.3302 22.0982 37.1808C20.1866 38.0295 17.8855 38.4598 15.2583 38.4598C12.5358 38.4598 10.177 38.0055 8.24724 37.1101C6.31369 36.2128 4.71943 34.9956 3.509 33.492C2.3017 31.9934 1.40423 30.2322 0.842284 28.2578C0.282851 26.2973 0 24.2144 0 22.0677V5.2207H8.4078V22.0677C8.4078 23.2875 8.53323 24.4592 8.77971 25.5502C9.02242 26.6311 9.42318 27.6079 9.9707 28.4535C10.5094 29.2876 11.215 29.9584 12.0686 30.4468C12.9171 30.9333 13.9908 31.1794 15.2583 31.1794C16.5252 31.1794 17.6058 30.9257 18.4713 30.4247C19.3406 29.9212 20.0555 29.2428 20.5943 28.4087C21.1399 27.565 21.5319 26.5825 21.7602 25.4871ZM44.7238 12.4097H34.4276V5.2207H63.3801V12.4097H53.1315V38.1866H44.7238V12.4097ZM122.033 16.4664C122.033 17.6918 121.721 18.7058 121.106 19.48C120.499 20.2429 119.803 20.6139 118.978 20.6139H112.175V12.4097H118.74C119.545 12.4097 120.278 12.7656 120.983 13.4975C121.68 14.2232 122.033 15.222 122.033 16.4664ZM127.284 24.4138C127.982 23.743 128.584 22.9764 129.071 22.1353C129.556 21.2954 129.934 20.3886 130.193 19.4415C130.452 18.4919 130.584 17.4911 130.584 16.4664C130.584 15.0971 130.296 13.7221 129.728 12.38C129.162 11.0467 128.367 9.8352 127.365 8.7789C126.361 7.72324 125.156 6.85751 123.785 6.20695C122.405 5.55261 120.884 5.2207 119.262 5.2207H103.766V38.1866H112.175V27.7574H116.767L123.553 38.1866H133.076L125.213 25.961C125.971 25.5256 126.667 25.0063 127.284 24.4138ZM158.417 23.6547V5.2207H166.825V38.1866H160.103L145.048 20.2435V38.1866H136.639V5.2207H143.172L143.267 5.33428L158.417 23.6547Z"
          }
        ),
        /* @__PURE__ */ jsx45(
          "path",
          {
            d: "M85.9097 8.83303H89.4011V21.8268C89.4011 22.9863 89.2994 24.1459 89.0621 25.2713C88.8249 26.3627 88.452 27.3517 87.8757 28.2043C87.3334 29.0228 86.6215 29.7049 85.7741 30.2165C84.8928 30.6939 83.8081 30.9667 82.5539 30.9667C81.2658 30.9667 80.215 30.728 79.3675 30.2165C78.5201 29.739 77.8083 29.0569 77.2659 28.2384C76.7236 27.3858 76.3168 26.3968 76.0456 25.3054C75.8083 24.2141 75.6727 23.0545 75.6727 21.8268V5.01334H67.3001V21.8268C67.3001 23.9754 67.5713 26.0557 68.1476 27.9997C68.6899 29.9777 69.6051 31.7511 70.7915 33.2176C72.0118 34.7523 73.605 35.946 75.5371 36.8327C77.4693 37.7535 79.8421 38.1969 82.5539 38.1969C85.164 38.1969 87.469 37.7535 89.4011 36.935C91.2994 36.0824 92.8925 34.8887 94.1467 33.3882C95.4009 31.9217 96.3161 30.1823 96.9263 28.2043C97.5025 26.2262 97.8076 24.0777 97.8076 21.8268V8.83303H101.197L93.401 4.10984e-06L85.9097 8.83303Z",
            fill: `url(#${fillId})`
          }
        ),
        /* @__PURE__ */ jsx45("defs", { children: /* @__PURE__ */ jsxs21(
          "linearGradient",
          {
            id: fillId,
            x1: "67.3001",
            y1: "19.0983",
            x2: "101.197",
            y2: "19.0983",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ jsx45("stop", { stopColor: "#00BFEC" }),
              /* @__PURE__ */ jsx45("stop", { offset: "1", stopColor: "#00C587" })
            ]
          }
        ) })
      ]
    })
  );
}

// src/components/uturn-ui/empty-state.tsx
import { jsx as jsx46 } from "react/jsx-runtime";
function EmptyState(_a) {
  var _b = _a, { children } = _b, props = __objRest(_b, ["children"]);
  return /* @__PURE__ */ jsx46("div", __spreadProps(__spreadValues({ className: "flex justify-center items-center mt-12" }, props), { children: /* @__PURE__ */ jsx46("div", { className: "flex flex-col text-center space-y-5 w-[18rem] md:w-[40rem]", children }) }));
}

// src/components/uturn-ui/date-picker/index.tsx
import { isValid, parse } from "date-fns";
import { useState as useState9 } from "react";
import { jsx as jsx47, jsxs as jsxs22 } from "react/jsx-runtime";
var inputDatetimeFormatOptions = {
  dateStyle: "short",
  timeStyle: "short"
};
var browserPreferredLanguage = window.navigator.language;
function formatDate(date, options = {}) {
  if (!date)
    return void 0;
  return new Intl.DateTimeFormat(browserPreferredLanguage, options).format(
    new Date(date)
  );
}
function formatDatetime(date, options = inputDatetimeFormatOptions) {
  return formatDate(date, options);
}
var DatePicker = (_a) => {
  var _b = _a, {
    placeholderText = "Choose a date",
    value,
    type,
    defaultOpen = false,
    onSelect,
    refCallback,
    onCloseHandler
  } = _b, props = __objRest(_b, [
    "placeholderText",
    "value",
    "type",
    "defaultOpen",
    "onSelect",
    "refCallback",
    "onCloseHandler"
  ]);
  const [open, setOpen] = useState9(defaultOpen);
  const timeIntervals = Array.from({ length: 24 * 6 }, (_, i) => {
    const hour = Math.floor(i / 6);
    const minute = i % 6 * 10;
    return {
      hour,
      minute
    };
  });
  const selectedHour = value ? value.getHours() : void 0;
  const selectedMinute = value ? value.getMinutes() : void 0;
  const isSelectedInterval = (interval) => selectedHour === interval.hour && selectedMinute === interval.minute;
  return /* @__PURE__ */ jsxs22(Popover, { defaultOpen, open, onOpenChange: setOpen, children: [
    /* @__PURE__ */ jsx47(PopoverTrigger, { className: "flex w-full", children: /* @__PURE__ */ jsx47(
      Input,
      {
        ref: (elem) => (
          // @ts-expect-error - says elem.input is not defined but it exists and works
          elem && refCallback && refCallback(elem.input)
        ),
        "data-empty": !value,
        className: "data-[empty=true]:text-muted-foreground flex w-full justify-start bg-transparent text-left font-normal",
        onClick: () => setOpen(true),
        value: formatDatetime(value == null ? void 0 : value.toISOString()),
        placeholder: placeholderText,
        onPaste: (e) => {
          const clipboardValue = e.clipboardData.getData("Text");
          const parsedDate = parse(
            clipboardValue,
            "dd-MM-yyyy, HH:mm",
            /* @__PURE__ */ new Date()
          );
          if (isValid(parsedDate)) {
            onSelect(parsedDate);
            return;
          }
          const date = new Date(clipboardValue);
          if (isValid(date)) {
            onSelect(date);
          }
        }
      }
    ) }),
    /* @__PURE__ */ jsx47(
      PopoverContent,
      {
        className: "w-auto p-0",
        onOpenAutoFocus: (e) => e.preventDefault(),
        children: /* @__PURE__ */ jsxs22("div", { className: "flex", children: [
          /* @__PURE__ */ jsx47(
            Calendar,
            __spreadProps(__spreadValues({
              mode: "single"
            }, props), {
              onSelect: (date) => {
                var _a2, _b2;
                if ((value == null ? void 0 : value.getHours()) !== 0 || (value == null ? void 0 : value.getMinutes()) !== 0) {
                  date == null ? void 0 : date.setHours(
                    (_a2 = value == null ? void 0 : value.getHours()) != null ? _a2 : 0,
                    (_b2 = value == null ? void 0 : value.getMinutes()) != null ? _b2 : 0,
                    0,
                    0
                  );
                  onSelect(date);
                  if (type === "date") {
                    setOpen(false);
                  }
                  return;
                }
                onSelect(date);
                if (type === "date") {
                  setOpen(false);
                }
              }
            })
          ),
          type === "datetime" && /* @__PURE__ */ jsx47("div", { className: "flex flex-col divide-y sm:h-[300px] sm:flex-row sm:divide-x sm:divide-y-0", children: /* @__PURE__ */ jsxs22(ScrollArea, { className: "w-64 sm:w-auto", children: [
            /* @__PURE__ */ jsxs22("div", { className: "flex gap-0.5 p-3 sm:flex-col", children: [
              /* @__PURE__ */ jsx47("p", { className: "text-muted-foreground mb-3 pt-1 text-center text-sm", children: "Time" }),
              timeIntervals.map((time) => /* @__PURE__ */ jsx47(
                Button,
                {
                  "data-time-key": `${time.hour}:${time.minute}`,
                  size: "icon",
                  disabled: !value,
                  variant: isSelectedInterval(time) ? "default" : "ghost",
                  className: "aspect-auto h-auto shrink-0 p-1 sm:w-full",
                  onClick: () => {
                    if (!value) {
                      return;
                    }
                    value.setHours(time.hour);
                    value.setMinutes(time.minute);
                    onSelect(value);
                    if (onCloseHandler) {
                      onCloseHandler();
                    }
                    setOpen(false);
                  },
                  children: `${time.hour}:${time.minute === 0 ? "00" : time.minute}`
                },
                `${time.hour}:${time.minute}`
              ))
            ] }),
            /* @__PURE__ */ jsx47(ScrollBar, { orientation: "horizontal", className: "sm:hidden" })
          ] }) })
        ] })
      }
    )
  ] });
};

// src/components/uturn-ui/chart/chart.tsx
import {
  Line,
  LineChart,
  ReferenceLine,
  ResponsiveContainer,
  Tooltip as Tooltip2,
  XAxis,
  YAxis
} from "recharts";

// src/components/uturn-ui/chart/chart-custom-tooltip.tsx
import { jsx as jsx48, jsxs as jsxs23 } from "react/jsx-runtime";
function ChartCustomTooltip({
  active,
  payload,
  customLabel
}) {
  if (active && payload && payload.length) {
    const { payload: data } = payload[0];
    return /* @__PURE__ */ jsxs23("div", { className: "bg-opacity-78 bg-secondary rounded px-3 py-2", children: [
      /* @__PURE__ */ jsx48("div", { className: "text-secondary-foreground text-lg font-semibold", children: data.name }),
      /* @__PURE__ */ jsx48("div", { className: "text-secondary-foreground text-sm", children: `${customLabel != null ? customLabel : ""} ${data.x}` })
    ] });
  }
  return null;
}

// src/components/uturn-ui/chart/chart.tsx
import { jsx as jsx49, jsxs as jsxs24 } from "react/jsx-runtime";
function Chart({
  data,
  ticks = [],
  tickFormatter,
  tooltipYdescription,
  tooltipVisible = true
}) {
  const style = {
    tick: {
      fill: "rgb(148, 174, 184)",
      fontSize: 12
    },
    stroke: {
      color: "rgb(148, 174, 184)",
      width: 1.5,
      opacity: 0.8
    },
    cursor: {
      className: "stroke-success-500 stroke-[0.4] [stroke-dasharray:5]"
    },
    line: {
      stroke: "rgb(23, 191, 234)",
      strokeWidth: 3,
      dot: {
        r: tooltipVisible ? 5 : 1,
        strokeWidth: 1
      }
    }
  };
  return /* @__PURE__ */ jsx49(ResponsiveContainer, { minHeight: "400", width: "100%", height: "100%", children: /* @__PURE__ */ jsxs24(
    LineChart,
    {
      data,
      margin: {
        right: 10
      },
      children: [
        /* @__PURE__ */ jsx49(
          XAxis,
          {
            dataKey: "name",
            angle: 0,
            textAnchor: "middle",
            tickLine: false,
            tick: style.tick,
            className: "stroke-secondary-100"
          }
        ),
        /* @__PURE__ */ jsx49(
          YAxis,
          {
            allowDataOverflow: true,
            domain: [ticks[0], ticks[-1]],
            ticks,
            tickFormatter,
            tick: style.tick,
            className: "stroke-secondary-100"
          }
        ),
        /* @__PURE__ */ jsx49(
          ReferenceLine,
          {
            y: ticks[3],
            stroke: style.stroke.color,
            strokeWidth: style.stroke.width,
            strokeOpacity: style.stroke.opacity
          }
        ),
        /* @__PURE__ */ jsx49(
          Tooltip2,
          {
            cursor: style.cursor,
            content: tooltipVisible ? /* @__PURE__ */ jsx49(ChartCustomTooltip, { customLabel: tooltipYdescription }) : () => null
          }
        ),
        /* @__PURE__ */ jsx49(
          Line,
          {
            type: "natural",
            dataKey: "x",
            stroke: style.line.stroke,
            strokeWidth: style.line.strokeWidth,
            dot: style.line.dot
          }
        )
      ]
    }
  ) });
}

// src/components/uturn-ui/chart/average-line.tsx
import { jsx as jsx50, jsxs as jsxs25 } from "react/jsx-runtime";
function AverageLine({ min, max, average }) {
  return /* @__PURE__ */ jsxs25("div", { className: "relative ml-7 mr-10 mt-14 flex size-auto content-center", children: [
    /* @__PURE__ */ jsx50("div", { className: "bg-muted-foreground/20 h-0.5 w-full flex-1" }),
    /* @__PURE__ */ jsxs25("div", { className: "absolute top-0 flex flex-col", children: [
      /* @__PURE__ */ jsx50("div", { className: "bg-muted-foreground/20 size-2 -translate-x-px -translate-y-2/4 rounded-full" }),
      /* @__PURE__ */ jsxs25("div", { className: "-mt-12 flex -translate-x-1/2 flex-col justify-center", children: [
        /* @__PURE__ */ jsx50("div", { className: "text-muted-foreground text-xs", children: "Lowest" }),
        /* @__PURE__ */ jsxs25("div", { className: "text-xs font-bold", children: [
          "\u20AC ",
          min
        ] })
      ] })
    ] }),
    /* @__PURE__ */ jsxs25("div", { className: "absolute left-1/2 top-0 flex flex-col", children: [
      /* @__PURE__ */ jsx50("div", { className: "bg-primary size-3 -translate-x-1/2 -translate-y-2/4 rounded-full" }),
      /* @__PURE__ */ jsxs25("div", { className: "text-primary -mt-12 -translate-x-1/2 text-xl font-bold", children: [
        "\u20AC ",
        average
      ] })
    ] }),
    /* @__PURE__ */ jsxs25("div", { className: "absolute right-0 top-0 flex translate-x-full flex-col", children: [
      /* @__PURE__ */ jsx50("div", { className: "bg-muted-foreground/20 size-2 -translate-y-2/4 rounded-full" }),
      /* @__PURE__ */ jsxs25("div", { className: "-mt-12 flex -translate-x-1/2 flex-col items-end justify-center", children: [
        /* @__PURE__ */ jsx50("div", { className: "text-muted-foreground text-xs", children: "Highest" }),
        /* @__PURE__ */ jsxs25("div", { className: "text-xs font-bold", children: [
          "\u20AC ",
          max
        ] })
      ] })
    ] })
  ] });
}

// src/components/index.ts
__reExport(components_exports, uturn_ui_exports);

// src/components/shadcn-ui/theme-provider.tsx
import { createContext as createContext2, useContext as useContext2, useEffect as useEffect3, useState as useState10 } from "react";
import { jsx as jsx51 } from "react/jsx-runtime";
var initialState = {
  theme: {
    color: "blue",
    mode: "system"
  },
  setMode: () => null,
  setColor: () => null
};
var ThemeProviderContext = createContext2(initialState);
function ThemeProvider(_a) {
  var _b = _a, {
    children,
    defaultMode = "system",
    defaultColor = "blue",
    storageKey = "ui-theme"
  } = _b, props = __objRest(_b, [
    "children",
    "defaultMode",
    "defaultColor",
    "storageKey"
  ]);
  const [theme, setTheme] = useState10(() => {
    const localTheme = localStorage.getItem(storageKey);
    const defaultTheme = {
      mode: defaultMode,
      color: defaultColor
    };
    if (localTheme === null) {
      return defaultTheme;
    }
    try {
      return JSON.parse(localTheme);
    } catch (e) {
      localStorage.setItem(storageKey, JSON.stringify(defaultTheme));
      return defaultTheme;
    }
  });
  useEffect3(() => {
    const root = window.document.body;
    root.classList.remove("light", "dark");
    if (theme.mode === "system") {
      const systemTheme = window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
      root.classList.add(systemTheme);
      return;
    }
    root.classList.add(`theme-${theme.color}`, theme.mode);
  }, [theme]);
  const value = {
    theme,
    setMode: (newMode) => {
      const newTheme = __spreadProps(__spreadValues({}, theme), {
        mode: newMode
      });
      localStorage.setItem(storageKey, JSON.stringify(newTheme));
      setTheme(newTheme);
    },
    setColor: (newColor) => {
      const newTheme = __spreadProps(__spreadValues({}, theme), {
        color: newColor
      });
      const root = window.document.body;
      root.classList.remove(`theme-${theme.color}`);
      localStorage.setItem(storageKey, JSON.stringify(newTheme));
      setTheme(newTheme);
    }
  };
  return /* @__PURE__ */ jsx51(ThemeProviderContext.Provider, __spreadProps(__spreadValues({}, props), { value, children }));
}
var useTheme = () => {
  const context = useContext2(ThemeProviderContext);
  if (context === void 0)
    throw new Error("useTheme must be used within a ThemeProvider");
  return context;
};

// src/components/shadcn-ui/mode-toggle.tsx
import { faBrightness, faMoon } from "@fortawesome/pro-regular-svg-icons";
import { useTranslation } from "react-i18next";
import { jsx as jsx52, jsxs as jsxs26 } from "react/jsx-runtime";
function ModeToggle() {
  const { setMode } = useTheme();
  const { t } = useTranslation();
  return /* @__PURE__ */ jsxs26(DropdownMenu, { children: [
    /* @__PURE__ */ jsx52(DropdownMenuTrigger, { asChild: true, children: /* @__PURE__ */ jsxs26(
      Button,
      {
        variant: "outline",
        size: "icon",
        className: "flex items-center justify-center",
        children: [
          /* @__PURE__ */ jsx52("div", { className: "rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0", children: /* @__PURE__ */ jsx52(Icon, { icon: faBrightness, size: "lg", fixedWidth: true }) }),
          /* @__PURE__ */ jsx52("div", { className: "rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100 absolute", children: /* @__PURE__ */ jsx52(Icon, { icon: faMoon, size: "lg", fixedWidth: true }) }),
          /* @__PURE__ */ jsx52("span", { className: "sr-only", children: t("general.themes.toggle", "Toggle theme") })
        ]
      }
    ) }),
    /* @__PURE__ */ jsxs26(DropdownMenuContent, { align: "end", children: [
      /* @__PURE__ */ jsx52(DropdownMenuItem, { onClick: () => setMode("light"), children: t("general.themes.light", "Light mode") }),
      /* @__PURE__ */ jsx52(DropdownMenuItem, { onClick: () => setMode("dark"), children: t("general.themes.dark", "Dark mode") }),
      /* @__PURE__ */ jsx52(DropdownMenuItem, { onClick: () => setMode("system"), children: t("general.themes.system", "Follow system") })
    ] })
  ] });
}

// src/components/sonner/sonner.tsx
import { useTheme as useTheme2 } from "next-themes";
import { Toaster as Toaster2, toast as sonner } from "sonner";
import { jsx as jsx53 } from "react/jsx-runtime";
var Sonner = (_a) => {
  var props = __objRest(_a, []);
  const { theme = "system" } = useTheme2();
  return /* @__PURE__ */ jsx53(
    Toaster2,
    __spreadValues({
      theme,
      className: "toaster group",
      toastOptions: {
        classNames: {
          toast: "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground"
        }
      }
    }, props)
  );
};

// src/index.ts
__reExport(src_exports, components_exports);
export {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  AgGridReact,
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  AlertDialogPortal,
  AlertDialogTitle,
  AlertDialogTrigger,
  AutoComplete,
  Avatar,
  AvatarFallback,
  AvatarImage,
  AverageLine,
  Badge,
  Breadcrumb,
  BreadcrumbEllipsis,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
  Button,
  Calendar,
  Callout,
  CalloutIcon,
  CalloutTitle,
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
  Chart,
  ChartCustomTooltip,
  Checkbox,
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
  Command,
  CommandDialog,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
  CommandSeparator,
  CommandShortcut,
  CopyToClipboard,
  DatePicker,
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogOverlay,
  DialogPortal,
  DialogTitle,
  DialogTrigger,
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuPortal,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSeparator,
  DropdownMenuShortcut,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuTrigger,
  EmptyState,
  Form,
  FormControl,
  FormDescription,
  FormField,
  FormFieldReadOnly,
  FormItem,
  FormLabel,
  FormMessage,
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
  Icon,
  Input,
  InputAddon,
  Label2 as Label,
  LicenseManager,
  Logo,
  ModeToggle,
  money_cell_default as MoneyCell,
  MultiSelect,
  MultiSelectBadge2 as MultiSelectBadge,
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuIndicator,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  NavigationMenuTrigger,
  NavigationMenuViewport,
  Pagination,
  PaginationCompact,
  PaginationContent,
  PaginationEllipsis,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
  Popover,
  PopoverContent,
  PopoverSelect,
  PopoverTrigger,
  RadioGroup2 as RadioGroup,
  RadioGroupItem,
  Ratings,
  ScrollArea,
  ScrollBar,
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectScrollDownButton,
  SelectScrollUpButton,
  SelectSeparator,
  SelectTrigger,
  SelectValue,
  Separator3 as Separator,
  Sheet,
  SheetClose,
  SheetContent,
  SheetDescription,
  SheetFooter,
  SheetHeader,
  SheetOverlay,
  SheetPortal,
  SheetTitle,
  SheetTrigger,
  Skeleton,
  Sonner,
  Stars,
  Switch,
  Table,
  TableBody,
  TableCaption,
  TableCell,
  TableFooter,
  TableHead,
  TableHeader,
  TableRow,
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
  Textarea,
  ThemeProvider,
  Toast,
  ToastAction,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
  Toaster,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
  badgeVariants,
  buttonVariants,
  cn,
  defaultInitials,
  format,
  formatDate,
  formatDatetime,
  getRandomColor,
  inputDatetimeFormatOptions,
  navigationMenuTriggerStyle,
  reducer,
  sonner,
  toast,
  useFormField,
  useTheme,
  useToast
};
//# sourceMappingURL=index.js.map